<template>
    <div class="container-fluid" id="dvcrud">        
        <div class="row">
            <detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="false"></detalhespedido>
            <consultaclientes></consultaclientes>
            <descontotitulo v-bind:titulo="vlegtitulo"></descontotitulo>
            <gerarparcelas v-bind:vproptipo=0></gerarparcelas>
            <gerarparcelasgrupo ></gerarparcelasgrupo>
            <baixartitulosreceber v-bind:vdtbaixa           = "pdtbasebaixa"
                             v-bind:vidclientebaixa         = "vidclientebaixa"
                             v-bind:proplstselecionados     = "vvariaveisbaixar.lstselecionadosbaixa"
                             v-bind:vclientebaixa           = "idnomeclientebaixa"
                             v-bind:vvariaveisbaixarcmp     = "vvariaveisbaixar"
                             v-bind:propvaldescontojuros    = "valdescontojuros"
                             v-bind:propvaldescontomulta    = "valdescontomulta"
                             v-bind:propidlancamentopdv     = "0"
                             v-bind:propidpdv               = "0"
                             @recibosimplificado            = "mtdimprimereciboemassa">
            </baixartitulosreceber>
            <detalhestituloreceber  v-bind:idcliente = "didcliente" 
                                    v-bind:codtit    = "dcodtit" 
                                    v-bind:situacao  = "dsituacao">
            </detalhestituloreceber>
            <geralinkrillpay    :codfil='null'
                                :descfil='""'
                                :idcliente= 'idclienterp'
                                :nomecliente="nomeclienterp">
            </geralinkrillpay>
            <alertacliente v-bind:idcliente="vidclientealerta"></alertacliente>		
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar títulos" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Atribuir campos" style="margin-right: 10px;" @click.prevent="mtdrotinacampos()"><span aria-hidden="true"><i class="fa fa-list"></i></span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerar títulos" style="margin-right: 10px;" @click.prevent="mtdgerarparcelas(1)"><span aria-hidden="true"><i class="fa fa-gear"></i></span></button>
                        <button v-show="mtdverificapermissao('030Z.010Z.180Z')" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Gerar títulos em massa" style="margin-right: 10px;" @click.prevent="mtdgerarparcelas(2)"><span aria-hidden="true"><i class="fa fa-gears"></i></span></button>
                        <!--Luiz Trindade - Botão para abrir Modal para listagem de valores a receber por filial-->
                        <button type="button" v-show="mtdverificamaparecebimento()" class="close" data-dismiss="modal" aria-label="Close" title="Mapa de recebimentos" style="margin-right: 10px;" @click.prevent="mtdtotalporfilial()"><span aria-hidden="true"><i class="fa fa-pie-chart"></i></span></button>
                        <!--Luiz Trindade - Botão para abrir Modal para listagem de ocorrências por período-->
                        <button v-show="usuarioPermissaoOcorrenciaPeriodo == true" type="button" class="close" data-dismiss="modal" aria-label="Close" title="Ocorrências por período" style="margin-right: 10px;" @click.prevent="mtdocorrenciasporperiodo()"><span aria-hidden="true"><i class="fa fa-flag"></i></span></button>                        
                        <button type="button" class="close" data-dismiss="modal" title="Guia de cobrança" style="margin-right: 10px;" @click.prevent="mtdGuiaCobranca()"><span aria-hidden="true"><i class="fa fa-file"></i></span></button>                        
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialpesq" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilial">
                                </select>
                            </div>  
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="cbtipopessoa">Tp. Pessoa:</label>
                                <select class="form-control form-control-sm" id="cbtipopessoa" v-model="ptipopessoa">
                                    <option value="0">Física</option>
                                    <option value="1">Jurídica</option>
                                    <option value="2">Extrangeiro</option>
                                    <option value="3">Todas</option>
                                </select>
                            </div>  
                            <div v-show="psituacao == 1" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Filial baixa:</span>
                                <select id="cbfilialbaixapesq" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfilialbaixa">
                                </select>
                            </div>                                                    
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Cliente:</span>
                                <select id="cbclientepesq" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                        style="width:100%;" v-model="pidcliente">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoriapesq" data-placeholder="Selecione uma categoria" data-allow-clear="true"
                                    v-model="pidcategoria" style="width:100%;">
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Município:</span>
                                <select id="cbcidadepesq" data-placeholder="Selecione uma cidade" data-allow-clear="true"
                                    v-model="pidcidade" style="width:100%;">
                                </select>
                            </div>                             
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Vendedor:</span>
                                <select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" data-allow-clear="true"
                                    v-model="pidvendedor" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Tipo de cobrança:</span>
                                <select id="cbtipocobrancapesq" v-model="pidtipocobranca"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>  
                            <div v-show="parseInt(vtipocobrancapesq)===1" class="col-sm-12 col-md-1 col-lg-1">
                                <span class="lblselect2">Sit. Cheque:</span>
                                <select id="cbsitchequepesq" data-placeholder="Selecione uma situação" data-allow-clear="true"
                                    v-model="pidsituacaocheque" style="width:100%;">
                                </select>
                            </div>                          
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Banco(boleto):</span>
                                <select id="cbbancoboletopesq" data-placeholder="Selecione um banco" data-allow-clear="true"
                                    v-model="pidbancoboleto" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Cobrador:</span>
                                <select id="cbcobradorpesq" data-placeholder="Selecione um cobrador" data-allow-clear="true"
                                    v-model="pidcobrador" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Rota:</span>
                                <select id="cbrotapesq" data-placeholder="Selecione um rota" data-allow-clear="true"
                                    v-model="pidrota" style="width:100%;">
                                </select>
                            </div>                                                                                    
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="cbSitTitulo">Situação</label>
                                <select class="form-control form-control-sm" id="cbSitTitulo" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Baixados</option>
                                    <option value="2">Cancelados</option>
                                    <option value="3">Renegociados</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
                            <div :class="psituacao == 1 ? 'col-sm-12 col-md-1 col-lg-1' :  'col-sm-12 col-md-2 col-lg-2'">
                                <label for="cbfiltropor">Por:</label>
                                <select class="form-control form-control-sm" id="cbfiltropor" v-model="ppor" @change="mtdlimpar_listagem()">
                                    <option value="0">Dt. Vencimento</option>
                                    <option value="1">Dt. Emissão</option>
                                    <option value="2">Dt. da baixa</option>
                                    <option value="3">Dt. de retorno</option>
                                    <option value="4">Dt. de renegociação</option>
                                </select>
                            </div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>  
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="edcodauxiliarpesq">Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodauxiliarpesq" v-model="pcodauxiliar" title="Código auxiliar"
                                    maxlength="30" data-bv-group=".group" @change="mtdlimpar_listagem()">
                            </div>                            
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="cbordempesq">Ordem:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbordempesq" v-model="pordem" @change="mtdlimpar_listagem()">
                                    <option value="0">Cliente</option>
                                    <option value="1">Emissão</option>
                                    <option value="2">Vencimento</option>
                                    <option value="3">Pagamento</option>
                                </select>
                            </div>                                                                                  
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="cblistar">Listar:</label>
                                <select class="form-control form-control-sm" id="cblistar" v-model="pativosinativos" @change="mtdlimpar_listagem()">
                                    <option value="0">Ativos</option>
                                    <option value="1">Inativos</option>
                                    <option value="2" selected="true">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtbasebaixa">Dt. Base/Baixa:</label>
								<div class="input-group">
									<date-picker id="eddtbasebaixa" v-model="pdtbasebaixa" :config="options" class="form-control form-control-sm" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                         
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div v-show="parseInt(vtipocobrancapesq)===1" class="col-sm-10 col-md-11 col-lg-10" >

                            </div>
                            <div :class="psituacao == 1 || parseInt(vtipocobrancapesq)!== 1 ? 'col-6 col-sm-6 col-md-1 col-lg-1' : 'col-6 col-sm-6 col-md-1 col-lg-2'">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <!-- visualização para abertos e renegociados -->
                            <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos" @on-select-row="mtdcalculaselecionados()"
                                    @on-unselect-row="mtdcalculaselecionados()"
                                    @on-all-select-rows="mtdcalculaselecionados()"
                                    @on-all-unselect-rows="mtdcalculaselecionados()"
                                        :rows="lsttitulos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->  
                                    <template v-if="item.row.registroerro" slot="slot_status" slot-scope="item">
                                        <!-- <i class="fa fa-exclamation-triangle icone-alerta-erro" style="font-size: 25px;"></i> -->
                                        <i class="fa fa-exclamation-triangle" style="font-size: 25px;"></i>
                                        <span class="tooltip-status">{{item.row.registroerro}}</span>
                                    </template>                                  
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>  
                                   <!-- <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)" title="Alterar"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)" title="Cancelar"><i class="fa fa-ban"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idcliente, item.row.codtit, 'A')" title="Informções"><i class="fa fa-info-circle"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button>  
                                            <button v-if="parseInt(psituacao) === 0" type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdaplicardesconto(item.row)" title="Desconto"><i class="fa fa-percent"></i></button>
                                        </div>                                 -->
                                    </template>
                                    <template slot="slot_nomecliente" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idcliente, 8) }} - {{ item.row.nomecliente }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                     
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span>{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>                                    
                                    <template slot="slot_vlapagar" slot-scope="item">
                                        <span style="color: #5A956A; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlapagar), 2) }}</span>
                                    </template> 
                                    <template slot="slot_nossonumero" slot-scope="item">
                                        <template v-if="parseInt(item.row.nossonumero) > 0 && !item.row.registroerro">
                                            <i class="fa fa-print icone-impressao-boleto" title="Imprimir boleto" @click.prevent="mtdimprimirboleto(item.row)"></i>
                                            <span style="color: #95989a; font-weight: 700;">{{ mtdformatarzeros(item.row.nossonumero, 8) }}</span>
                                        </template>
                                        <template v-if="parseInt(item.row.nossonumero) > 0 && item.row.registroerro">
                                            <i class="fa fa-print icone-impressao-boleto" style="color: #bb7b7b;" title="Imprimir boleto" @click.prevent="mtdimprimirboleto(item.row)"></i>
                                            <span style="color: #95989a; font-weight: 700; color: #bb7b7b; text-decoration: line-through;">{{ mtdformatarzeros(item.row.nossonumero, 8) }}</span>
                                            <span class="tooltip-boleto-erro">Boleto com inconsistência. Verifique o alerta de erros.</span>
                                        </template>
                                    </template>                                    
									<template slot="slot_detalhes" slot-scope="item">
                                        <i v-if="parseInt(item.row.idpedido) > 0" @click.prevent="mtddetalhespedido(item.row.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido/venda"></i>
										<span v-else></span>
                                    </template>	
									<template slot="slot_alertacli" slot-scope="item">
                                        <i v-if="parseInt(item.row.alertarcliente) === 1" @click.prevent="mtdvisualizaralerta(item.row.idcliente)" class="fa fa-exclamation-triangle icone-alerta-cliente-tit" title="Alerta para o cliente"></i>
										<span v-else></span>
                                    </template>                                    									                                                                                                             
                                </vue-bootstrap4-table>
                            </div>
                            <!-- visualização dos cancelados -->
                            <div v-show="parseInt(psituacao) === 2" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnscancelados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarcancelamento(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idcliente, item.row.codtit, 'C')" title="Informações"><i class="fa fa-info-circle"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button>  
                                        </div>
                                    </template>
                                    <template slot="slot_nomecliente" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idcliente, 8) }} - {{ item.row.nomecliente }}
                                    </template>
                                    <template slot="slot_vltit" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vltit), 2) }}</span>
                                    </template>
									<template slot="slot_detalhes" slot-scope="item">
                                        <i v-if="parseInt(item.row.idpedido) > 0" @click.prevent="mtddetalhespedido(item.row.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido/venda"></i>
										<span v-else></span>
                                    </template>
									<template slot="slot_alertacli" slot-scope="item">
                                        <i v-if="parseInt(item.row.alertarcliente) === 1" @click.prevent="mtdvisualizaralerta(item.row.idcliente)" class="fa fa-exclamation-triangle icone-alerta-cliente-tit" title="Alerta para o cliente"></i>
										<span v-else></span>
                                    </template>                                                                        
                                </vue-bootstrap4-table>
                            </div> 
                            <!-- visualização dos baixados -->
                            <div v-show="parseInt(psituacao) === 1" class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttitulos"
                                        :columns="columnsbaixados"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdestornarbaixa(item.row)" title="Estornar"><i class="fa fa-mail-reply"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtddetalhestitulo(item.row.idcliente, item.row.codtit, 'B')" title="Informações"><i class="fa fa-info-circle"></i></button>
                                            <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button>
                                            <!-- <button type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" @click.prevent="mtdarquivostitulo(item.row)" title="Arquivos"><i class="fa fa-file"></i></button> -->
                                            
                                            <!--Luiz Trindade - Adição de um botão para verificar títulos-->
                                            <!-- <button v-show="usuarioPermissaoVerificarTitulo == true" type="button" class="btn btn-warning btn-sm btn-opcrud ajt-btn" 
                                                @click.prevent="mtdverificartitulo(item.row)" title="Verificar">
                                                <i class="fa fa-check-square"></i>
                                            </button> -->
                                        </div> 
                                    </template>
                                    <template slot="slot_nomecliente" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.idcliente, 8) }} - {{ item.row.nomecliente }}
                                    </template>
                                    <template slot="slot_atraso" slot-scope="item">
                                        <span v-if="parseInt(item.row.atraso) > 0" class="badge badge-pill badge-danger">{{ item.row.atraso }}</span>
                                        <span v-else></span>
                                    </template>

                                    <!--Luiz Trindade - Template de verificados-->
                                    <template slot="slot_verificado" slot-scope="item">
                                        <div @click.prevent="mtdverificartitulo(item.row)" title="Verificar" style="font-size: 20px">
                                            <div v-if="parseInt(item.row.verificado) == 1" style="color: green">
                                                <i class="fa fa-check-square-o" aria-hidden="true"></i>
                                            </div>
                                            <div v-else style="color: #2F3C48">
                                                <i class="fa fa-square-o" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </template>

                                    <template slot="slot_vlresta" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>
                                    <template slot="slot_vljuros" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vljuros), 2) }}</span>
                                    </template>
                                    <template slot="slot_vlmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template> 
                                    <template slot="slot_valordescontojurosmulta" slot-scope="item">
                                        <span style="color: #95989a; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.valordescontojurosmulta), 2) }}</span>
                                    </template>                                                                                                             
                                    <template slot="slot_vlpago" slot-scope="item">
                                        <span style="font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlpagtit) + parseFloat(item.row.vljuros) + parseFloat(item.row.vlmulta), 2) }}</span>
                                    </template>
									<template slot="slot_detalhes" slot-scope="item">
                                        <i v-if="parseInt(item.row.idpedido) > 0" @click.prevent="mtddetalhespedido(item.row.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido/venda"></i>
										<span v-else></span>
                                    </template>
									<template slot="slot_alertacli" slot-scope="item">
                                        <i v-if="parseInt(item.row.alertarcliente) === 1" @click.prevent="mtdvisualizaralerta(item.row.idcliente)" class="fa fa-exclamation-triangle icone-alerta-cliente-tit" title="Alerta para o cliente"></i>
										<span v-else></span>
                                    </template>
                                    <!-- exibe a origem de baixa do titulo -->
									<template slot="slot_origembaixa" slot-scope="item">
                                        <!-- inicialmente temos somente o rillpay -->
                                        <!-- 0 - padrao -->
                                        <!-- 1 - rillpay -->
                                        <img v-if="parseInt(item.row.origembaixa) === 1" src="/icone-rpay.svg" style="width: 25px; height: 25px; fill: black;" alt="icone rillpay" title="Origem de baixa RIllpay">
										<span v-else></span>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>                             
                            <div class="col-md-12">
                                <div v-show="parseInt(psituacao) === 0 || parseInt(psituacao) === 3" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vrVencidos), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vrAvencer), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vrJuros), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vrMulta), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(parseFloat(vrTotal), 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Selecionados <span class="badge badge-info bdgtitulos">{{ vqtdtitsel }}</span></a>
                                                    <a class="list-group-item lstdetrec">Soma dos títulos <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vTotalPagarSel), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vTotalJurosSel), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vTotalMultaSel), 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total geral à pagar <span
                                                            class="badge badge-success bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vTotalGeralSel), 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-show="parseInt(psituacao) === 1" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total juros <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaljurosrec, 2) }}</span></a>
                                                    <a class="list-group-item lstdetrec">Total descontos <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaldescontorec, 2) }}</span></a>
                                                </ul>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotalmultarec, 2) }}</span></a>                                                    
                                                    <a class="list-group-item lstdetrec">Total recebido <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(parseFloat(vtotalgeralrec), 2) }}</span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                                <div v-show="parseInt(psituacao) === 2" class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total cancelado(s) <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulos.length }}</span>
                                                        <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(parseFloat(vrTotcancelados), 2) }}</span></a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-2 col-sm-2 col-md-4 col-lg-4" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button v-show="parseInt(psituacao) === 0 && pidcliente !== null && lsttitulos.length > 0 && vqtdtitsel > 0" type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdbaixartitulos()"><i class="fa fa-check"></i> Baixar</button>
                            </div>                                                                    
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtddefinircontaboletos()"><i class="fa fa-barcorde"></i> Definir Conta boletos</button>
                            </div>                                                                                    
                            <div class="col-2 col-sm-2 col-md-2 col-lg-2">
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimecartacobranca()"><i class="fa fa-file-invoice"></i> Imprimir carta de cobranca</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimeboletoemassa()"><i class="fa fa-barcode"></i> Imprimir boletos dos selecionados</a>
                                        <a v-if="mtdverificapermissao('030Z.010Z.170Z')" class="dropdown-item" href="#" @click.prevent="mtdimprimepromissoriaemassa()"><i class="fa-solid fa-file-invoice-dollar"></i> Imprimir promissória dos selecionados</a>
                                        <a v-if="mtdverificapermissao('030Z.010Z.170Z')" class="dropdown-item" href="#" @click.prevent="mtdimprimereciboemassa()"><i class="fa fa-sticky-note-o"></i> Imprimir recibo simplificado</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdabremodalimp()"><i class="fa fa-print"></i> Exportar</a>                                                                                                                     
                                    </div>
                                </div>  
                            </div>                                    
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="edcodcli">*Cliente:</label>
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-sm" id="edcodcli" v-model="vidcliente" v-bind:disabled="ativadesativaCodCli" maxlength="11" v-on:blur="mtdlocalizarcliente(vidcliente)" style="text-transform: uppercase;">
                                    <div class="input-group-append">
                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarcliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-5">
                                <label for="ednomecliente">Nome do cliente:</label>
                                <input type="text" class="form-control form-control-sm" id="ednomecliente" v-model="vnomecliente"
                                    data-bv-group=".group" maxlength="50" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="edcodtit">*Nº Título:</label>
                                <input type="text" class="form-control form-control-sm" id="edcodtit" v-model="vcodtit"
                                    v-bind:disabled="ativadesativaCodTit" maxlength="30" style="text-transform: uppercase;"
                                    data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcodtit">Cod. Auxiliar:</label>
                                <input type="text" class="form-control form-control-sm" id="edauxiliar" v-model="vcodauxiliar" v-bind:disabled="ativadesativa"
                                    maxlength="30" style="text-transform: uppercase;" data-bv-group=".group">
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">*Tipo de cobrança:</span>
                                <select id="cbtipocobranca" v-model="vidtipocobranca" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione o tipo de cobrança" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemitit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtvenc">*Dt. Vencimento:</label>
								<div class="input-group">
									<date-picker id="eddtvenc" v-model="vdtventit" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
                            <div class="col-sm-12" v-show="parseInt(tipocob) === 1">
                                <div class="card" id="pnlcheque" style="margin-top: 15px; margin-bottom: 10px;">
                                    <div class="card-header card-in text-center" style="padding: 5px;"><span>DADOS DO CHEQUE</span></div>
                                    <div class="card-body" style="padding-bottom: 15px;">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="ednumcheque">*Nº Cheque:</label>
                                                <input type="text" class="form-control form-control-sm" id="ednumcheque"
                                                    v-model="vnumerocheque" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-7">
                                                <span class="lblselect2">*Banco:</span>
                                                <select id="cbbanco" v-model="vidbanco" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione um banco" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edagencia">*Agência:</label>
                                                <input type="text" class="form-control form-control-sm" id="edagencia"
                                                    v-model="vagencia" v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edconta">*Conta:</label>
                                                <input type="text" class="form-control form-control-sm" id="edconta" v-model="vconta"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-5">
                                                <label for="edpraca">*Praça:</label>
                                                <input type="text" class="form-control form-control-sm" id="edpraca" v-model="vpraca"
                                                    v-bind:disabled="ativadesativa" maxlength="20"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edemitente">*Emitente:</label>
                                                <input type="text" class="form-control form-control-sm" id="edemitente"
                                                    v-model="vemitente" v-bind:disabled="ativadesativa" maxlength="50"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="edcnpjcpfch">*Cnpj/Cpf:</label>
                                                <input type="text" v-mask="['##.###.###/####-##', '###.###.###-##']" class="form-control form-control-sm" id="edcnpjcpfch"
                                                    v-model="vcnpjcpf" v-bind:disabled="ativadesativa" maxlength="30"
                                                    style="text-transform: uppercase;" data-bv-group=".group">
                                            </div>
                                            <div class="col-sm-12 col-md-9 col-lg-9">
                                                <span class="lblselect2">*Situação do Cheque:</span>
                                                <select id="cbsitcheque" v-model="vidsituacaocheque" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione a situação do cheque" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <span class="lblselect2">*Vendedor:</span>
                                <select id="cbvendedor" v-model="vidvendedor" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione um vendedor" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-5">
                                <span class="lblselect2">*Cobrador:</span>
                                <select id="cbcobrador" v-model="vidcobrador" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione um cobrador" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbsituacao">Situação:</label>
                                <select class="form-control form-control-sm" v-model="vinativo" id="cbsituacao"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Ativo</option>
                                    <option value="1">Inativo</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpjuros">Tipo de juros:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcjuros" id="cbtpjuros"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatjuros">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatjuros" v-bind="moneyprecision" v-model="vfatjuros"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtpmulta">Tipo de multa:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcmulta" id="cbtpmulta"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edfatmulta">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatmulta" v-bind="money" v-model="vfatmulta"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>
                            <div class="col-sm-2 col-md-2 col-lg-2">
                                <label for="edvalortit">*Valor do título:</label>
                                <money class="form-control form-control-sm" id="edvalortit" v-bind="money" v-model="vvltit"
                                    v-bind:disabled="ativadesativa" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right; background: #0acf97; color: white; font-weight: bold;"></money>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="txtobs">Observações:</label>
                                <textarea class="form-control center" rows="4" id="txtobs" v-model="vobstit"
                                        style="text-transform: uppercase;"
                                        v-bind:disabled="ativadesativa"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Confirmar
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">IMPORTAÇÃO DE CONTAS À RECEBER</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">Importação de cadastro</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>                                    
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbimportarcodigos" v-model="vimportarcodigos">
                                        <label class="custom-control-label" for="cbimportarcodigos" style="color: #f82b54;">Manter códigos</label>
                                    </div>
                                </div>                                 
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Cancelar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>                
            </div>
        </div>

        <!-- Atribuir campos --> 
        <div class="modal fade" id="mdatribuircampos" tabindex="-1">
            <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-leanpub" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir campos aos títulos</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-top: 5px;">                        
                        <div class="row">
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirsituacao" v-model="vatribuirsituacao">
                                    <label class="custom-control-label" for="cbatribuirsituacao"></label>
                                </div>
                            </div>                            
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="cbsituacaocampos">Situação:</label>
                                <select class="form-control form-control-sm" id="cbsituacaocampos" v-model="vsituacaocampos" v-bind:disabled="!vatribuirsituacao">
                                    <option value="0">Inativo</option>
                                    <option value="1">Ativo</option>
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirauxiliar" v-model="vatribuirauxiliar">
                                    <label class="custom-control-label" for="cbatribuirauxiliar"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-5">
                                <label for="edauxiliarcampos">Cod. Auxiliar:</label>
                                <input type="text" v-model="vauxiliarcampos"
                                        class="form-control form-control-sm" id="edauxiliarcampos" maxlength="20" v-bind:disabled="!vatribuirauxiliar">
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridfilial" v-model="vatribuiridfilial">
                                    <label class="custom-control-label" for="cbatribuiridfilial"></label>
                                </div>
                            </div>                                                        
                            <div class="col-md-11">
                                <span class="lblselect2">Filial:</span>
                                <select id="cbfilialcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidfilialcampos" v-bind:disabled="!vatribuiridfilial"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridtipocobranca" v-model="vatribuiridtipocobranca">
                                    <label class="custom-control-label" for="cbatribuiridtipocobranca"></label>
                                </div>
                            </div>
                            <div class="col-md-11">
                                <span class="lblselect2">Tipo de cobrança:</span>
                                <select id="cbtipocobrancacampos" data-placeholder="Selecione uma opção"
                                    v-model="vidtipocobrancacampos" v-bind:disabled="!vatribuiridtipocobranca"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridvendedor" v-model="vatribuiridvendedor">
                                    <label class="custom-control-label" for="cbatribuiridvendedor"></label>
                                </div>
                            </div>                            
                            <div class="col-md-11">
                                <span class="lblselect2">Vendedor:</span>
                                <select id="cbvendedorcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidvendedorcampos" v-bind:disabled="!vatribuiridvendedor"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuiridcobrador" v-model="vatribuiridcobrador">
                                    <label class="custom-control-label" for="cbatribuiridcobrador"></label>
                                </div>
                            </div>                            
                            <div class="col-md-11">
                                <span class="lblselect2">Cobrador:</span>
                                <select id="cbcobradorcampos" data-placeholder="Selecione uma opção"
                                    v-model="vidcobradorcampos" v-bind:disabled="!vatribuiridcobrador"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirjuros" v-model="vatribuirjuros">
                                    <label class="custom-control-label" for="cbatribuirjuros"></label>
                                </div>
                            </div>                            
                            <div class="col-md-5">
                                <label for="cbtpjuroscampos">Tipo de juros:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcjuroscampos" id="cbtpjuroscampos"
                                        v-bind:disabled="!vatribuirjuros">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="edfatjuros">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatjuroscampos" v-bind="money" v-model="vfatjuroscampos"
                                    v-bind:disabled="!vatribuirjuros" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div>                             
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirmulta" v-model="vatribuirmulta">
                                    <label class="custom-control-label" for="cbatribuirmulta"></label>
                                </div>
                            </div>                            
                            <div class="col-md-5">
                                <label for="cbtpmultacampos">Tipo de multa:</label>
                                <select class="form-control form-control-sm" v-model="vtpcalcmultacampos" id="cbtpmultacampos"
                                        v-bind:disabled="!vatribuirmulta">
                                    <option value="0" selected="true">Percentual (%)</option>
                                    <option value="1">Valor (R$)</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label for="edfatmulta">Fator (%):</label>
                                <money class="form-control form-control-sm" id="edfatmultacampos" v-bind="money" v-model="vfatmultacampos"
                                    v-bind:disabled="!vatribuirmulta" value="0,00" maxlength="20" data-bv-group=".group"
                                    style="text-align:right;"></money>
                            </div> 
                            <div class="col-sm-1 col-md-1 col-lg-1">                            
                                <div class="custom-control custom-switch" style="margin-top: 23px; margin-left: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbatribuirobstit" v-model="vatribuirobstit">
                                    <label class="custom-control-label" for="cbatribuirobstit"></label>
                                </div>
                            </div>
                            <div class="col-sm-11 col-md-5 col-lg-12">
                                <label for="txtobs">Observações:</label>
                                <textarea class="form-control center" rows="2" id="txtobs" v-model="vobstit" style="text-transform: uppercase;" v-bind:disabled="!vatribuirobstit"></textarea>
                            </div>
                            <div class="col-md-12" style="padding-top: 10px; padding-bottom: 15px;">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swctodostitulos" name="swctodostitulos" v-model="vatribuitodostitulos">
                                    <label class="custom-control-label" for="swctodostitulos" 
                                           title="Esta opção irá atribuir os campos marcados para todos os títulos cadastrados no sistema, sem exceção. Tenha certeza absoluta ao realizar esta operação!">Aplicar campos para todos os títulos cadastrados</label>
                                </div>                                
                            </div>                                                   
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuircampos()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>
        
		<!-- Modal para atribuir a conta para emissão dos boletos -->
		<div class="modal fade" id="mddefinecontaboleto">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-barcode"></i> Definir conta para emissão de boletos</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<span class="lblselect2">Conta bancária:</span>
							<select id="cbcontaboletodef" data-placeholder="Selecione uma conta" v-model="vidcontaboletodef" data-allow-clear="true" style="width:100%;">
							</select>
						</div>		
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdatribuircontabancaria()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>       
        
        <!-- Modal definições de impressão -->
		<div class="modal fade" id="mddefineimp">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-print"></i> Definir exportação</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
                        <div  v-if="pgrupamento==1" class="col-12">
                            <label for="cbgrupamento">Agrupar:</label>
                            <select class="form-control form-control-sm" id="cbgrupamento" v-model="pgrupamento">
                                <option value="0">Não agrupar</option>
                                <option value="1">Cliente</option>
                                <option value="2">Emissão</option>
                                <option value="3">Vencimento</option>
                                <option v-if="parseInt(psituacao)===1" value="4">Filial baixa</option>
                            </select>
                        </div>  
                        <div  v-if="pgrupamento==1" class="col-6">
                            <label for="cbenderecocli">Informar endereço:</label>
                            <select class="form-control form-control-sm" id="cbenderecocli" v-model="penderecocli">
                                <option value="0">Não informar</option>
                                <option value="1">Informar</option>
                            </select>
                        </div>   
                        <div  v-if="pgrupamento==1" class="col-6">
                            <label for="cbenderecocli">Ordem:</label>
                            <select class="form-control form-control-sm" id="cbenderecocli" v-model="pordemcli">
                                <option value="0">Código</option>
                                <option value="1">Nome/Razão</option>
                                <option value="2">Fantasia</option>
                            </select>
                        </div>  
                        <div  v-else class="col-12">
                            <label for="cbgrupamento">Agrupar:</label>
                            <select class="form-control form-control-sm" id="cbgrupamento" v-model="pgrupamento">
                                <option value="0">Não agrupar</option>
                                <option value="1">Cliente</option>
                                <option value="2">Emissão</option>
                                <option value="3">Vencimento</option>
                                <option v-if="parseInt(psituacao)===1" value="4">Filial baixa</option>
                            </select>
                        </div>  	
					</div>
				</div>
				<div class="modal-footer">
                    <button v-if="pidcliente !== null" type="button" class="btn btn-primary btn-sm corvermelho" style="width: 100px;" @click.prevent="mtdEnviarPdfEmail()"><i class="fa fa-paper-plane"></i> Email </button>
                    <button v-else type="button" class="btn btn-primary btn-sm corvermelho" style="width: 100px;" @click.prevent="mtdModalPreencherEmail()"><i class="fa fa-envelope"></i> Enviar por Email </button>
                    <button type="button" class="btn btn-primary btn-sm corverde" style="width: 100px;" @click.prevent="mtdgerarpdf(0)"><i class="fa fa-file-excel-o"></i> Excel </button>
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdgerarpdf(1)"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>   

        <!-- Modal para enviar o email -->
        <div class="modal fade" id="mddefineimpemail">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-print"></i> Enviar por email</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
                        <div class="col-12">
                            <label for="edemailimpressao">Email:</label>
                            <input type="text" v-model="vemailimpressao"
                                    class="form-control form-control-sm" id="edemailimpressao">
                        </div> 	
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdEnviarPdfEmail()"><i class="fa fa-print"></i> Enviar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>     
        
        <!-- Modal para visualizar os dados do título -->
        <div class="modal fade" id="mdlarquivostitulo">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-files-o"></i> Arquivos do título: {{legtituloarq.codtit}}, R$ {{mtdformatavalordecimal(parseFloat(legtituloarq.vlresta), 2)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <div class="card">
                                    <div class="card-body" style="padding: 2px; min-height: 40px;">
                                        <div class="row text-center" style="padding: 15px;">
                                            <div v-for="arquivo in lstarquivostitulo" class="col-md-4 dv-arq-lista">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank">
                                                            <i v-if="extensaocxalta(arquivo.arquivo) === 'JPG' || extensaocxalta(arquivo.arquivo) === 'JPEG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PDF'" class="fa fa-file-pdf-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'DOC' || extensaocxalta(arquivo.arquivo) === 'DOCX'" class="fa fa-file-word-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XLS' || extensaocxalta(arquivo.arquivo) === 'XLSX'" class="fa fa-file-excel-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PPT' || extensaocxalta(arquivo.arquivo) === 'PPTX'" class="fa fa-file-powerpoint-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'TXT'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'ZIP' || extensaocxalta(arquivo.arquivo) === 'RAR'" class="fa fa-file-archive-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP3'" class="fa fa-file-audio-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP4' || extensaocxalta(arquivo.arquivo) === 'AVI'" class="fa fa-file-video-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'HTML'|| extensaocxalta(arquivo.arquivo) === 'HTM'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSS'" class="fa fa-css3 icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'JS'"  class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PHP'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'SQL'" class="fa fa-database icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSV'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XML'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'GIF'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PNG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'BMP'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else class="fa fa-file-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i class="fa fa-close icon-del-arquivo" @click.prevent="mtdexcluirarquivo(arquivo.patharquivo)"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <a class="link-arquivo" v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank"><h6 class="tit-arquivo">{{ arquivo.arquivo }}</h6></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                                         
                            <div  class="col-md-12 text-center" style="margin-top: 15px;">
                                <input
                                    type="file" 
                                    id="ipselecionarimg"
                                   
                                    @change="mtdselecionararquivotit" 
                                    style="display: none;"
                                    ref="filestit">
                                <button type="button" @click="$refs.filestit.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar arquivo</button>
                            </div>                              
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>            
                </div>
            </div>
        </div>

         <!-- Menu do produto --> 
		<div class="modal fade" id="mdmenutitulo" tabindex="-1">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ menutitulo.codtit }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(menutitulo)" data-dismiss="modal"><i class="fa fa-edit"></i> ALTERAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(menutitulo)" data-dismiss="modal"><i class="fa fa-ban"></i> EXCLUIR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddetalhestitulo(menutitulo.idcliente, menutitulo.codtit, 'A')" data-dismiss="modal"><i class="fa fa-info-circle"></i> DETALHES</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdarquivostitulo(menutitulo)" data-dismiss="modal"><i class="fa fa-file"></i> ARQUIVOS</li>
                                <!--Luiz Trindade - Opção para abrir o modal de ocorrências (Ainda será implementado, não apagar!)-->
                                <li v-show="usuarioPermissaoOcorrencia == true" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdocorrencias(menutitulo)" data-dismiss="modal"><i class="fa fa-flag"></i> OCORRÊNCIAS</li>
                                <li v-if="parseInt(psituacao) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdaplicardesconto(menutitulo)" data-dismiss="modal"><i class="fa fa-percent"></i> DESCONTO</li>
                                <li v-if="parseInt(psituacao) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdaplicardesconto(menutitulo)" data-dismiss="modal"><i class="fa fa-percent"></i> DESCONTO</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdgerarlinkrillpay(menutitulo)" data-dismiss="modal"><i class="fa fa-link" aria-hidden="true" style="font-size: 10px;"></i> GERAR LINK RILLPAY</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>

        <!--Luiz Trindade - Modal para manipular ocorrências de títulos-->
        <div class="modal fade" id="mdlocorrenciastitulo" tabindex="-1">
			<div class="modal-dialog modal-xl">
                <!--Luiz Trindade - Conteúdo do modal-->
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçc-lho do modal-->
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-flag"></i>
                            Ocorrências do título: "<b>{{ vocodtit }}"</b>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body">
                        <div class="row"><!--Luiz Trindade - Nome do cliente-->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="onomecliente">Cliente:</label>
                                <input type="text" class="form-control form-control-sm" id="onomecliente" 
                                    v-model="vonomecliente"disabled :title="vonomecliente"
                                    style="overflow: auto; text-overflow: ellipsis">
                            </div>

                            <!--Luiz Trindade - Número do cliente-->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="onomecliente">Telefone:</label>
                                <input type="text" class="form-control form-control-sm" id="onomecliente" 
                                    v-model="vonumerocliente"disabled :title="vonumerocliente"
                                    style="overflow: auto; text-overflow: ellipsis">
                            </div>

                            <!--Luiz Trindade - Código do título-->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="emailtit">Email:</label>
                                <input type="text" class="form-control form-control-sm" id="emailtit" 
                                    v-model="voemailcliente"disabled :title="voemailcliente"
                                    style="overflow: auto; text-overflow: ellipsis">
                            </div>
                        </div>

                        <div class="row">
                            <!--Luiz Trindade - Data de ocorrência-->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="odataocorrencia">Data de ocorrência:</label>
                                <input type="text" class="form-control form-control-sm" id="odataocorrencia" 
                                    v-model="vodtocorrencia" disabled :title="vodtocorrencia">
                            </div>

                            <!--Luiz Trindade - Retorno, sim ou não, padrão = não-->
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="oretorno">Retorno:</label>
                                <select class="form-control form-control-sm" id="oretorno" v-model="voretorno">
                                    <option value="0" selected>Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>

                            <!--Luiz Trindade - Horário de retorno-->
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="odataretorno">Horário:</label>
                                <input type="text" class="form-control form-control-sm" 
                                id="horaioretorno" v-model="vodtretornohora"
                                :disabled="voretorno == 0"
                                :title="vodtretornohora"
                                v-mask="['##:##']">
                            </div>

                            <!--Luiz Trindade - Data de retorno-->
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="odataretorno">Data de retorno:</label>
                                <!-- <input type="text" class="form-control form-control-sm" id="odataretorno" 
                                    v-model="vodtretorno" :disabled="voretorno == 0" :title="vodtretorno"> -->

                                <div class="input-group">
									<date-picker id="odataretotno" :config="options" 
                                        class="form-control form-control-sm"
                                        v-model="vodtretorno" :disabled="voretorno == 0" :title="vodtretorno" 
                                        @change="mtdlimpar_listagem()">
                                    </date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
                            </div>
                        </div>
                        <hr>
                        
                        <div class="row">
                            <div class="col">
                                <textarea name="oconteudo" id="oconteudo" v-model="voconteudo" 
                                    style="width: 100%; height: 120px; font-size: 20px; text-align: justify">
                                </textarea>

                                <!--Luiz Trindade - Botão de adicionar-->
                                <div class="col-sm-12 col-md-4 col-lg-12 text-right" style="padding-top: 15px">
                                    <button type="button" class="btn btn-success" @click="mtdconfirmaadicaoocorrencia()" style="width: 150px;">
                                        <i class="fa fa-plus"></i>
                                        Adicionar
                                    </button>
                                </div>
                                <hr>

                                <table class="table table-bordered" style="margin-top: 20px">
                                    <thead class="thead-dark">
                                        <tr style="text-align: center">
                                            <!-- <th>Detalhes</th> -->
                                            <th>Título</th>
                                            <th>Usuário</th>
                                            <th>Data de ocorrência</th>
                                            <th>Data de retorno</th>
                                            <th>Conteúdo</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-show="lstOcorrencias.length != 0" v-for="(ocorrencia, index) in lstOcorrencias" v-bind:key="index">
                                            <!-- <td style="text-align: center;">
                                                <button class="btn btn-primary" 
                                                @click="mtdexibirmodalocorrencia(index, ocorrencia.id)">
                                                    <i class="fa fa-info-circle"></i>
                                                </button>
                                            </td> -->

                                            <td style="text-align: left;">{{ ocorrencia.codtit }}</td>
                                            <td style="text-align: left;">{{ ocorrencia.nomeusuario }}</td>
                                            <td style="text-align: left;">
                                                <i class="fa fa-calendar" style="color: green; font-size: 25px"></i>
                                                {{ ocorrencia.dtocorrencia.substring(0, 16) }}
                                            </td>
                                            
                                            <!--Luiz Trindade - Verificação da data de ocorrência-->
                                            <td style="text-align: center;" v-if="!(ocorrencia.dtretorno)">
                                                <i class="fa fa-calendar" style="color: red; font-size: 25px"></i>
                                                <span style="margin-left: 10px">Sem data de retorno</span>
                                            </td>
                                            <td style="text-align: center;" v-else>
                                                <i class="fa fa-calendar" style="color: green; font-size: 25px"></i>
                                                {{ ocorrencia.dtretorno.substring(0, 16) }}
                                            </td>

                                            <!--Luiz Trindade - Conteúdo da ocorrência-->
                                            <td style="text-align: left;">{{ ocorrencia.conteudo }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!--Luiz Trinbdade - botão de imprimir ocorrências-->
                                <div class="col-sm-12 col-md-4 col-lg-12 text-right" style="padding-top: 15px">
                                    <button type="button" class="btn btn-success" @click="mtdimprimirocorrencias()" style="width: 150px;">
                                        <i class="fa fa-print"></i>
                                        Imprimir
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>			        
                </div>
			</div>
		</div>

        <!--Luiz Trindade - Modal para exibir/editar ocorrência-->
        <div class="modal fade" id="mdlocorrencia" style="overflow: auto;" tabindex="-1">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!--Luiz Trindade - Conteúdo do modal-->
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçalho do modal-->
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-flag"></i>
                            Ocorrência do dia {{ vodtocorrenciaexibir.substring(0, 16) }}
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!--Luiz Trindade - Corpo do modal com o conteúdo da ocorrência-->
                    <div class="modal-body">
                        <p style="text-align: justify; font-size: 20px">
                            {{ voconteudoexibir }}
                        </p>
                        <hr>
                    </div>
                </div>
            </div>
        </div>

        <!--Luiz Trindade - Modal para visualizar informações por filial (mdltotalfilial)-->
        <div class="modal fade" id="mdltotalfilial" tabindex="-1">
			<div class="modal-dialog modal-lg">
                <!--Luiz Trindade - Conteúdo do modal-->
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçc-lho do modal-->
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-pie-chart"></i>
                            Mapa de recebimentos.
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-3">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-3">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>

                            <!--Luiz Trindade - Títulos a receber/pagos-->
                            <div class="col-sm-12 col-md-2 col-lg-3">
                                <label for="cbtipotit">Tp. Títulos:</label>
                                <select class="form-control form-control-sm" id="cbtipotit" v-model="tptit">
                                    <option value="0" default>À receber</option>
                                    <option value="1">Pagos</option>
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-2 col-lg-3" style="padding-top: 20px;">
                                <button id="lala" class="btn btn-primary btn-sm" @click="mtdlistartotalfilial()" title="Pesquisar">
                                    <i class="fa fa-search"></i>
                                    Pesquisar
                                </button>
                            </div>
                        </div>
                        <hr>

                        <!--Luiz Trindade - Área do gráfico-->
                        <div class="row">
                            <div class="card-body" style="padding-bottom: 10px;">
                                    <!--Luiz Trindade - Tipo de gráfico-->
                                    <div v-show="lstDadosGraficoTotalFilial.length > 0" class="row" style="margin-top: 20px;">
                                        <!--Luiz Trindade - Gráfico de setor-->
                                        <div v-show="tipografico == 0" class="col-md-12" style="margin-top: -40px;">
                                            <label>Gráfico de setor</label>
                                            <graficopie  	:titulo="''"
                                                            :subtitulo="''"
                                                            :rotulo="'Total por filial:'"
                                                            :legendas="lstLegendasGraficoTotalFilial"
                                                            :dados="lstDadosGraficoTotalFilial"
                                                            :visualizarlegenda="true"
                                                            :posicaolabel="'outside'"
                                            ></graficopie>
                                        </div>

                                        <!--Luiz Trindade - Gráfico de barra-->
                                        <div v-show="tipografico == 1" class="col-md-12" style="margin-top: -40px;">
                                            <label>Gráfico de setor (mínimo)</label>
                                            <graficodoughnut :rotulo="'DETALHES:'"
                                                             :legendas="lstLegendasGraficoTotalFilial"
                                                             :dados="lstDadosGraficoTotalFilial"
                                            ></graficodoughnut>
                                        </div>

                                        <!--Luiz Trindade - Gráfico de barra-->
                                        <div v-show="tipografico == 2" class="col-md-12" style="margin-top: -40px;">
                                            <label>Gráfico de barras</label>
                                            <graficobarra   :titulo = "''"
                                                            :agrupamento="lstLegendasGraficoFilial"
                                                            :series="lstDadosGraficoQuantidade"
                                            ></graficobarra>
                                        </div>
                                    </div>

                                    <div v-show="lstDadosGraficoTotalFilial.length == 0" class="row" style="margin-top: 20px;">
                                        <!--Luiz Trindade - Sem dados no gráfico-->
                                        <div class="col-md-12" style="margin-top: -40px;">
                                            <label>Sem dados para exibição</label>
                                        </div>
                                    </div>
                                </div>
                        </div>

                        <!--Luiz Trindade - Botão para alterar o tipo de gráfico-->
                        <div style="display: flex; align-items: center; justify-content: space-evenly; margin-top: 20px;">
                            <button id="tipodegrafico" class="btn btn-primary btn-sm" 
                            @click.prevent="mtdalterargrafico()" title="Tipo de gráfico">
                                Tipo de gráfico
                                <i class="fa fa-pie-chart"></i>
                                /
                                <i class="fa fa-bar-chart"></i>
                            </button>
                            
                            <!--Akira - Botão de imprimir-->
                            <button id="lala" class="btn btn-primary btn-sm" @click="mtdimprimirtotalfilial()" title="Imprimir">
                                <i class="fa fa-print"></i>
                                Imprimir
                            </button>
                        </div>
                        
                        <div class="row" style="margin-top: 20px;">
                            <div class="col" style="overflow: auto;">
                                <table class="table table-sm table-striped table-bordered">
                                    <!--Luiz Trindade - Cabeçalho da tabela-->
                                    <thead class="thead-dark">
                                        <tr>
                                            <th style="text-align: center;">Filial</th>
                                            <th style="text-align: center;">Fantasia</th>
                                            <th style="text-align: center;">Total títulos</th>
                                            <th style="text-align: center;">Total juros</th>
                                            <th style="text-align: center;">Total multa</th>
                                            <th v-show="tptit == 1" style="text-align: center;">Total descontos</th>
                                            <th style="text-align: center;">Total geral</th>
                                            <th style="text-align: center;">Porcentagem (%)</th>
                                        </tr>
                                    </thead>
    
                                    <!--Luiz Trindade - Corpo da tabela-->
                                    <tbody>
                                        <tr v-for="(filial, index) in lstTotalfilial" v-bind:key="index"> 
                                            <!-- <td>{{ filial.id }}</td> -->
                                            <td style="text-align: left;">{{ filial.idfilial }}</td>
                                            <td style="text-align: left;">{{ filial.fantasia }}</td>
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.totaltitulos), 2) }}</td>
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.totaljuros), 2) }}</td>
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.totalmulta), 2) }}</td>
                                            <td v-show="tptit == 1" style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.descontos), 2) }}</td>
                                            <td style="text-align: right;">{{ mtdformatavalordecimal(parseFloat(filial.totalgeral), 2) }}</td>
                                            <td style="text-align: right;">{{ mtdformatavalordecimal((filial.totalgeral /  vtotalfilialgeral) * 100, 2)}}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!--Luiz Trindade - Total geral valor-->
                        <div class="col-md-12">
                                <div class="card">
                                    <div class="card-body" style="padding: 15px;">
                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total Títulos 
                                                        <span class="badge badge-success bdgtitulos" style="background: #2F3C48;">
                                                            {{ mtdformatavalordecimal(parseFloat(vtotalfilialtitulos), 2) }}
                                                        </span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total Multa 
                                                        <span class="badge badge-success bdgtitulos" style="background: #CC330D;">
                                                            {{ mtdformatavalordecimal(parseFloat(vtotalfilialmulta), 2) }}
                                                        </span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-if="tptit == 1" class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total Descontos 
                                                        <span class="badge badge-success bdgtitulos" style="background: #6E9FA5;">
                                                            {{ mtdformatavalordecimal(parseFloat(vtotalfilialdescontos), 2) }}
                                                        </span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total Juros 
                                                        <span class="badge badge-success bdgtitulos" style="background: #5C8F94;">
                                                            {{ mtdformatavalordecimal(parseFloat(vtotalfilialjuros), 2) }}
                                                        </span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="row justify-content-center">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <ul class="list-group">
                                                    <a class="list-group-item lstdetrec">Total Geral 
                                                        <span class="badge badge-success bdgtitulos" style="background: #5A956A;">
                                                            {{ mtdformatavalordecimal(parseFloat(vtotalfilialgeral), 2) }}
                                                        </span>
                                                    </a>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>       
                            </div>
                    </div>

                    <!--Luiz Trindade - Rodapé do modal-->
                    <div class="modal-footer" style="padding: 5px;">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12 text-right">
                                </div>
                            </div>					
                        </div>
                    </div>				        
                </div>
			</div>
		</div>

        <!--Luiz Trindade - Modal para manipular ocorrências de títulos larylary-->
        <div class="modal fade" id="mdlocorrenciasperiodo">
			<div class="modal-dialog modal-xl">
                <!--Luiz Trindade - Conteúdo do modal-->
                <div class="modal-content">
                    <!--Luiz Trindade - Cabeçalho do modal-->
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-flag"></i>
                            Ocorrências por período
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!--Luiz Trindade - Corpo do modal-->
                    <div class="modal-body">
                        <div class="row">
                            <!--Luiz Trindade - Data de Início-->
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="odatainicio">Início:</label>
                                <div class="input-group">
									<date-picker id="odatainicio" :config="options" 
                                        class="form-control form-control-sm"
                                        v-model="vodtinicio" :title="vodtinicio" 
                                        @change="mtdlimpar_listagem()">
                                    </date-picker>

                                    <!--Ícone de calendário-->
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
                            </div>

                            <!--Luiz Trindade - Data Final-->
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="odatafim">Fim:</label>
                                <div class="input-group">
									<date-picker id="odatafim" :config="options" 
                                        class="form-control form-control-sm"
                                        v-model="vodtfim" :title="vodtfim" 
                                        @change="mtdlimpar_listagem()">
                                    </date-picker>

                                    <!--Ícone de calendário-->
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
                            </div>

                            <!--Luiz Trindade - Nome do usuário-->
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Usuário:</span>
                                <select title="Usuário" id="cbusuariopesq" data-placeholder="Selecione um usuário" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="voidusuariopesq">
                                </select>
                            </div>

                            <!--Luiz Trindade - Nome do cliente-->
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Cliente:</span>
                                <select title="Cliente" id="cbclientepesq2" data-placeholder="Selecione um cliente" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="voidnomepesq">
                                </select>
                            </div>

                            <!--Luiz Trindade - Ordernar por data de ocorrência ou retorno-->
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cboordernarpor">Ordem:</label>
                                <select class="form-control form-control-sm" 
                                title="Ordem"
                                id="cboordernarpor" 
                                v-model="voordernarpor">
                                    <option value="dtocorrencia" default>Ocorrência</option>
                                    <option value="dtretorno">Retorno</option>
                                </select>
                            </div>
    
                            <!--Luiz Trindade - Botão de pesquisar ocorrências por período-->
                            <div class="col-sm-12 col-md-4 col-lg-2 text-right" style="padding-top: 15px">
                                <button type="button" class="btn btn-success" 
                                title="Pesquisar" @click="mtdpesquisarocorrencias()" 
                                style="width: 150px; margin-left: 10px;">
                                    <i class="fa fa-search"></i>
                                </button>
                            </div>
                        </div>
                        <hr>

                        <div class="row" style="margin-top: 20px; max-height: 400px; overflow-y: auto;">
                            <div class="col">
                                <div class="col-md-12" style="margin-top: 10px;">
                                    <!--Luiz Trindade - Tabela com ocorrências-->
                                    <vue-bootstrap4-table
                                            :rows="lstOcorrenciasPeriodo"
                                            :columns="columnocorrenciasperiodo"
                                            :config="configOcorrencias"
                                            :classes="classes">
                                        <template slot="empty-results">
                                            <div class="col-md-12 text-center">
                                                Sem dados para visualização
                                            </div>
                                        </template>

                                        <!-- ícones de ordenação da table -->
                                        <template slot="sort-asc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                        </template>
                                        <template slot="sort-desc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                        </template>
                                        <template slot="no-sort-icon">
                                            <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                        </template>
                                        
                                        <tamplate slot="slot_dtocorrencia" slot-scope="item">
                                            <i class="fa fa-calendar" style="color: green; font-size: 16px"></i>
                                            {{ item.row.dtocorrencia.substring(0, 16) }}
                                        </tamplate>

                                        <template slot="slot_dtretorno" slot-scope="item" v-if="!(item.row.dtretorno)">
                                            <i class="fa fa-calendar" style="color: red; font-size: 16px"></i>
                                            <span style="margin-left: 10px">Sem data de retorno</span>
                                        </template>
                                        <template slot="slot_dtretorno" slot-scope="item" v-else>
                                            <i class="fa fa-calendar" style="color: green; font-size: 16px"></i>
                                            {{ item.row.dtretorno.substring(0, 16) }}
                                        </template>
                                    </vue-bootstrap4-table>
                                </div>    
                            </div>
                        </div>
                        
                        <hr>
                        <!--Luiz Trinbdade - botão de imprimir ocorrências por período-->
                        <div class="text-right">
                            <button type="button" class="btn btn-success"
                            title="Imprimir" @click="mtdimprimirocorrenciasperiodo()" 
                            style="width: 150px;">
                                <i class="fa fa-print"></i>
                                Imprimir
                            </button>
                        </div>
                    </div>			        
                </div>
			</div>
		</div>
        <div class="modal fade" id="mdlguiacobranca">
			<div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <i class="fa fa-file-invoice-dollar"></i>
                            Guia de cobrança
                        </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="odatainicioguia">Início:</label>
                                <div class="input-group">
									<date-picker id="odatainicioguia" :config="options" 
                                        class="form-control form-control-sm"
                                        v-model="vodtinicioguia" :title="vodtinicioguia" 
                                        @change="mtdlimpar_listagem()">
                                    </date-picker>

									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-2">
                                <label for="odatafimguia">Fim:</label>
                                <div class="input-group">
									<date-picker id="odatafimguia" :config="options" 
                                        class="form-control form-control-sm"
                                        v-model="vodtfimguia" :title="vodtfimguia" 
                                        @change="mtdlimpar_listagem()">
                                    </date-picker>

									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
                            </div>

                            
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Cliente:</span>
                                <select title="Cliente" id="cbclienteguia" data-placeholder="Selecione um cliente" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="vclienteguia">
                                </select>
                            </div>

                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Cidade:</span>
                                <select title="Cidade" id="cbcidadeguia" data-placeholder="Selecione uma cidade" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="vcidadeguia">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Bairro:</span>
                                <select title="Bairro" id="cbbairroguia" data-placeholder="Selecione um bairro" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="vbairroguia">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Filial:</span>
                                <select title="Filial" id="cbfilialguia" data-placeholder="Selecione uma filial" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="vfilialguia">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <span class="lblselect2">Rota:</span>
                                <select title="Rota" id="cbrotaguia" data-placeholder="Selecione uma rota" 
                                    data-allow-clear="true"
                                    style="width:100%;" 
                                    v-model="vrotaguia">
                                </select>
                            </div>


                        </div>
                        
                        <hr>
                        <div class="text-right">
                            <button type="button" class="btn btn-success"
                            title="Imprimir" @click="mtdImpressaoGuiaCobranca()" 
                            style="width: 150px;">
                                <i class="fa fa-print"></i>
                                Imprimir
                            </button>
                        </div>
                    </div>			        
                </div>
			</div>
		</div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import GraficoPie from '../components/cmpgraficopie.vue';
    import GraficoDoughnut from '../components/cmpgraficodoughnut.vue';
    import GraficoBarra from '../components/cmpgraficobarra.vue';
    import ConsultarClientes from '../components/cmpconsultarclientes.vue'
    import GerarParcelas from '../components/cmpgerarparcelas.vue'
    import GerarParcelasgrupo from '../components/cmpgerarparceslasgrupo.vue'
    import BaixarTitulosReceber from '../components/cmpbaixartitulosreceber'
    import DetalhesTituloReceber from '../components/cmpdetalhestituloreceber'
    import util from '../utilitarios/util.js'
    import DetalhesPedido from '../components/cmpdetalhespedido.vue'
    import Descontotitulo from '../components/cmpdescontotitulo.vue'
    import AlertaCliente from '../components/cmpconteudoalertacliente.vue'		
    export default {
        name: 'cadtitulosreceber',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'            : BreadCrumb,
            'consultaclientes'      : ConsultarClientes,
            'graficopie'		    : GraficoPie,
            'graficodoughnut'       : GraficoDoughnut,
            'graficobarra'          : GraficoBarra,
            'gerarparcelas'         : GerarParcelas,
            'gerarparcelasgrupo'    : GerarParcelasgrupo,
            'baixartitulosreceber'  : BaixarTitulosReceber,
            'detalhestituloreceber' : DetalhesTituloReceber,
            'detalhespedido'  		: DetalhesPedido,
            'descontotitulo'        : Descontotitulo,
			'alertacliente'			: AlertaCliente,
            'geralinkrillpay'       : () => import('../components/cmpgeralinkrillpay.vue')
        },
        data: function() {
            return {
                //Luiz Trindade - Lista com os totais por filial e variáveis do gráfico
                //Luiz Trinde - Sempre que novos gráficos forem adicionados, atualizar o valor de qntdgraficos
                qntdgraficos                    : 3, 
                tipografico                     : 0,
                tptit                           : 0,
                lstTotalfilial                  : [],
                lstDadosGraficoTotalFilial      : [],
                lstLegendasGraficoTotalFilial   : [],
                lstDadosGraficoQuantidade       : [],
                lstLegendasGraficoFilial        : [],
                vtotalfilialgeral               : 0.0,
                vtotalfilialtitulos             : 0.0,
                vtotalfilialjuros               : 0.0,
                vtotalfilialmulta               : 0.0,
                vtotalfilialdescontos           : 0.0,

                //modal defnições imp
                pgrupamento         : 0, 
                penderecocli        : 0,
                pordemcli           : 0,

                //Luiz Trindade - Variáveis para ocorrênicas de títulos
                usuarioPermissaoOcorrencia  : false,
                lstOcorrencias              : [],
                vocodtit                    : '',
                voidcliente                 : '',
                vonomecliente               : '',
                vonumerocliente             : '',
                voemailcliente              : '',
                vodtocorrencia              : '',
                voconteudo                  : '',
                voidusuario                 : this.$store.state.usuario.id,
                voretorno                   : 0,
                vodtretorno                 : util.DataAtual(true, false),
                vodtretornohora             : '14:00',
                vodtocorrenciaexibir        : '',
                voconteudoexibir            : '',

                //Luiz Trindade - Variáveis para verificar título
                // usuarioPermissaoVerificarTitulo     : false,
                codopVerificarTitulo                : "030Z.010Z.160Z",

                //Luiz Trindade - Variáveis para listar ocorrências
                usuarioPermissaoOcorrenciaPeriodo   : false,
                lstOcorrenciasPeriodo               : [],
                vodtinicio                          : util.DataAtual(true, false),
                vodtfim                             : util.DataAtual(true, false),
                vocliente                           : 0,
                voidnomepesq                        : null,
                voidusuariopesq                     : null,
                voordernarpor                       : 'dtocorrencia',

				//variável para detalhes do pedido
				vidpedidodet : '',
				/////////////////////                
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                lsttitulos          : [],
                pfiltro             : 1,
                pidfilial           : null,
                ptipopessoa         : 3,
                pidcliente          : null,
                pidtipocobranca     : null,
                pcodauxiliar        : '',
                pativosinativos     : 0,
                pidvendedor         : null,
                pidbancoboleto      : null,
                pidcobrador         : null,
                pidrota             : null,
                pidcategoria        : null,
                pidcidade           : null,
                pidsituacaocheque   : null,
                vtipocobrancapesq   : 0,
                pfiltroperiodo      : 1,
                ppor                : 0,
                hab_desab_periodo   : false,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true), 
                pdtbasebaixa        : util.DataAtual(true),
                psituacao           : 0,
                pordem              : 2,      

                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                ativadesativaCodCli : false,
                ativadesativaCodTit : false,
                opcrud              : 0,

                pidfilialbaixa      : null, 

                menutitulo          : [],  

                tipocob             : 0,//variável para determinar se é cheque ou não

                vidcliente          : '',
                vnomecliente        : '',
                vcodtit             : '',
                vsttit              : '',
                vcodauxiliar        : '',
                vidtipocobranca     : null,
                vidfilial           : null,
                vdtemitit           : util.DataAtual(true),
                vdtventit           : util.DataAtual(true),
                vnumerocheque       : '',
                vidbanco            : null,
                vagencia            : '',
                vconta              : '',
                vpraca              : '',
                vemitente           : '',
                vcnpjcpf            : '',
                vidsituacaocheque   : null,
                vidvendedor         : null,
                vidcobrador         : null,
                vinativo            : 0,
                vtpcalcjuros        : 0,
                vfatjuros           : 0,
                vtpcalcmulta        : 0,
                vfatmulta           : 0,
                vvltit              : 0,
                vobstit             : '',
              
                
                /// modal titulo arquivos
                legtituloarq        : [], 
                lstarquivostitulo   : [], 
                vpatharquivostit    : '',


                //variável para habilitação dos campos
                ativadesativa       : true,

                //variaveis de somas totais
                vrVencidos          : 0,
                vrAvencer           : 0,
                vrJuros             : 0,
                vrMulta             : 0,
                vrTotal             : 0,
                vrTotcancelados     : 0,

                //variaveis de somas dos baixados
                vtotaltitulosrec    : 0,
                vtotaljurosrec      : 0,
                vtotalmultarec      : 0,
                vtotaldescontorec   : 0,
                vtotalgeralrec      : 0,          

                //variáveis para os totais dos selecionados
                vqtdtitsel          : 0,
                vTotalPagarSel      : 0,
                vTotalJurosSel      : 0,
                vTotalMultaSel      : 0,
                vTotalGeralSel      : 0,                

                //baixa de titulo
                vidclientebaixa          : 0,
                idnomeclientebaixa       : '',
                valdescontojuros         : 0,
                valdescontomulta         : 0,
                vvariaveisbaixar : {
                    vtottitbaixa         : 0,
                    vtotmultabaixa       : 0,
                    vtotjurosbaixa       : 0,
                    vtotpagarbaixa       : 0,
                    lstselecionadosbaixa : [],
                    vvalorrecebimento    : 0,
                },

                //variaveis para detalhe do título
                didcliente           : '',
                dcodtit              : '',
                dsituacao            : 'A',//A - Aberto, B - Baixado, C - Cancelado, R - Renegociado

                //atribuição de campos			
                vatribuirsituacao 	: false,
                vsituacaocampos		: 1,

                vatribuirauxiliar	: false,
                vauxiliarcampos		: '',

                vatribuirobstit	    : false,
                vobstit		        : '',

                vatribuiridfilial	: false,
                vidfilialcampos		: null,

                vatribuiridtipocobranca : false,
                vidtipocobrancacampos	: null,
                vtipocobrancacampos     : 0,//determina se é cheque ou não

                vatribuiridvendedor		: false,
                vidvendedorcampos		: null,

                vatribuiridcobrador		: false,
                vidcobradorcampos		: null,
                
                vatribuirjuros          : false,
                vtpcalcjuroscampos      : 0,
                vfatjuroscampos         : 0,

                vatribuirmulta          : false,
                vtpcalcmultacampos      : 0,
                vfatmultacampos         : 0,

                vatribuitodostitulos    : false,

                //variável da importação
                vlimpardados            : false,
                vimportarcodigos        : false,
                arqselecionado          : null, 
                
                //Definição de boletos 
                vidcontaboletodef       : null,


                //aplicar descoto no titulo
                vlegtitulo              : [],

				//variavel para alerta de cliente
				vidclientealerta		: 0,                
                
                // variaveis link rillpay
                idclienterp             : null,
                nomeclienterp           : '',

                // variavel para impressao por email
                vemailimpressao         : '',

                // variaveis guia de cobrança
                vodtinicioguia          : util.DataAtual(true, false),
                vodtfimguia             : util.DataAtual(true, false),
                vclienteguia            : null,
                vcidadeguia             : null,
                vbairroguia             : null,
                vfilialguia             : null,
                vrotaguia               : null,

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                moneyprecision	    : {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 3,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'TÍTULOS À RECEBER',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: '',
                        name : 'status',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_status",
                        row_classes: "def-col-status",
                        sort: false
                    },
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-abertos",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomecliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomecliente",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    //Luiz Trindade - Data de retorno e contato
                    {
                        label: "Retorno",
                        name: "dtretorno",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Renegociação",
                        name: "dtrenegociacao",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "F. Emissão",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-femissao"
                    },
                    // {
                    //     label: "Contato",
                    //     name: "dtretorno",
                    //     sort: true,
                    //     row_text_alignment: "text-left",
                    //     column_text_alignment: "text-left",                        
                    //     row_classes: "def-col-datas"
                    // },

                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Restante",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
                    {
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                                                              
                    {
                        label: "Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    { 
                        label: "À receber",
                        name: "vlapagar",
                        sort: true,
                        slot_name: "slot_vlapagar",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "N. número",
                        name: "nossonumero",
                        sort: true,
                        slot_name: "slot_nossonumero",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-nossonumero"                     
                    },                                        
                    {
                        label: "",
                        name: "idpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "",
                        name: "alertarcliente",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_alertacli",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    }                    
                ],
                columnscancelados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomecliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomecliente",
                    },
                    {
                        label: "Tipo de cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },                                        
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vltit",
                        sort: true,
                        slot_name: "slot_vltit",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "",
                        name: "idpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "",
                        name: "alertarcliente",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_alertacli",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    }                                        
                ],

                //Luiz Trindade - Configuração da coluna de Ocorrências por período
                columnocorrenciasperiodo:[
                    {
                        label: "Título",
                        name: "codtit",
                        sort: true,
                        slot_name: "slot_codtit",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Valor",
                        name: "valor",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },
                    {
                        label: "Usuário",
                        name: "nomeusuario",
                        sort: true,
                        slot_name: "slot_nomeusuario",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        sort: true,
                        slot_name: "slot_nomecliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },                                        
                    {
                        label: "Contato",
                        name: "contato",
                        sort: true,
                        slot_name: "slot_contato",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },
                    {
                        label: "Data de ocorrência",
                        name: "dtocorrencia",
                        sort: false,
                        slot_name: "slot_dtocorrencia",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },
                    {
                        label: "Data de retorno",
                        name: "dtretorno",
                        sort: false,
                        slot_name: "slot_dtretorno",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center",
                    },
                    {
                        label: "Conteúdo",
                        name: "conteudo",
                        sort: true,
                        slot_name: "slot_conteudo",
                        initial_sort : false,
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-center"                        
                    },                                   
                ],

                columnsbaixados:[
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codtit"
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_nomecliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomecliente",
                    },
                    {
                        label: "Cobrança",
                        name: "desccob",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-desccob"
                    },
                    {
                        label: "Auxiliar",
                        name: "codauxiliar",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-codauxiliar"
                    },      
                    {
                        label: "F. baixa",
                        name: "fantasiabaixa",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                    },                                    
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
                    {
                        label: "Pagamento",
                        name: "dtpagtit",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-datas"
                    },
					{
                        label: "Atraso",
                        name: "atraso",
                        sort: true,
                        slot_name: "slot_atraso",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "Vl. títiulo",
                        name: "vlresta",
                        sort: true,
                        slot_name: "slot_vlresta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Juros",
                        name: "vljuros",
                        sort: true,
                        slot_name: "slot_vljuros",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Vl. Multa",
                        name: "vlmulta",
                        sort: true,
                        slot_name: "slot_vlmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
					{
                        label: "Descto(J/M)",
                        name: "valordescontojurosmulta",
                        sort: true,
                        slot_name: "slot_valordescontojurosmulta",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },                    
					{
                        label: "Total pago",
                        name: "vlpago",
                        sort: true,
                        slot_name: "slot_vlpago",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",                        
                        row_classes: "def-col-valores"
                    },
                    {
                        label: "",
                        name: "idpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "",
                        name: "alertarcliente",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_alertacli",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    //Luiz Trindade - Adição de uma coluna com informações de verificação de título
                    {
                        label: "",
                        name: "verificado",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_verificado",
                        // row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        visibility: false                        
                    },					
                    {
                        label: "",
                        name: "origembaixa",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_origembaixa",
                        // row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                    },					
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    //rows_selectable: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configOcorrencias: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    //rows_selectable: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdGuiaCobranca(){
                let vself = this;
                vself.vclienteguia      = null;
                vself.vcidadeguia       = null;
                vself.vbairroguia       = null;
                vself.vfilialguia       = null;
                vself.vrotaguia         = null;
                vself.vodtinicioguia    = util.DataAtual(true, false);
                vself.vodtfimguia       = util.DataAtual(true, false);
                $('#mdlguiacobranca').modal('show');
            },
            mtdImpressaoGuiaCobranca(){
                let vself = this;
                let filial       = vself.vfilialguia === null ? 'TODAS AS FILIAIS' : $('#cbfilialguia').select2('data')[0]['text'];
                let filtro = '';

                // if(vself.vclienteguia === null){
                //     vself.$toastr.e("Por favor, selecione um cliente!", 'Erro!');
                //     return;
                // }
				filtro = filtro + ' and t.dtventit between "' + util.InverterData(this.vodtinicioguia) + '" and "' + util.InverterData(this.vodtfimguia) + '"';
                if(vself.vclienteguia){
                    filtro += 'and cli.id='+vself.vclienteguia+' ';
                } 
                if(vself.vcidadeguia){
                    filtro += 'and m.id='+vself.vcidadeguia+' ';
                }
                if(vself.vbairroguia){
                    filtro += 'and b.id='+vself.vbairroguia+' ';
                }
                if(vself.vfilialguia){
                    filtro += 'and t.idfilial='+vself.vfilialguia+' ';
                }
                if(vself.vrotaguia){
                    filtro += 'and r.id='+vself.vrotaguia+' ';
                }

				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&op=imprimirguiacobranca'+
                            '&dtinicial='+vself.vodtinicioguia+
                            '&dtfinal='+vself.vodtfimguia+
                            '&filtro='+filtro+
                            '&filial='+filial+
                            '&idusuario='+vself.$store.state.usuario.id, '_blank');
            },
            mtdverificapermissao(op){
                if (util.opcaousuario(op, this.$store.state.perfilusuario)){
                    return true
                }else {
                    return false
                }
            },
            mtdverificamaparecebimento(){// assim que pecivel depreciar esses metodos repetitivos - guga
                if (util.opcaousuario("030Z.010Z.150Z", this.$store.state.perfilusuario)){
                    return true
                }else {
                    return false
                }
            },
            mtdmostrarmenu(titulo){				
				this.menutitulo = titulo;
				$('#mdmenutitulo').modal('show');
			}, 
            mtdexcluirarquivo(patharquivo){
                let vself = this;
                let loader       = vself.$loading.show();
                let localarquivo = 'controller/arquivostitulosr/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivostit;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Arquivo excluído com sucesso!', 'Informação!');
                        vself.lstarquivostitulo = [];
                        vself.lstarquivostitulo = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },
            extensaocxalta(nomearquivo) {
                var partes = nomearquivo.split('.');
                if (partes.length > 1) {
                    var extensao = partes.pop();
                    return extensao.toUpperCase();
                } else {
                    return "sem_ext";
                }
            },
            mtdselecionararquivotit(event){
                let vself = this;
                let arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivostitulosr/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivostit;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : arqimgselecionado.name},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('arquivo enviada com sucesso!', 'Informação!');
                        vself.lstarquivostitulo = [];
                        vself.lstarquivostitulo = response.data.arquivos;

                    
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });     
            },
            mtdpreparamodalarq(path){
                var vself       = this;
                let loader      = vself.$loading.show();
                let patharquivos= 'controller/arquivostitulosr/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + path;
                let parametros  = [
                    {parametro: 'op',               valor  : 'listararquivos'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'patharquivos',     valor  : patharquivos},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstarquivostitulo = []
                    vself.lstarquivostitulo = response.data
                    vself.vpatharquivostit  = path;
                    $('#mdlarquivostitulo').modal('show');
                    
                }).catch(function (response) {
                    loader.hide();
                });

            },

            mtdarquivostitulo(titulo){
                this.legtituloarq = titulo;
                var vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'verificapath'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'codtit',           valor  : titulo.codtit},
                    {parametro: 'idcliente',        valor  : titulo.idcliente},
                    {parametro: 'situacao',         valor  : vself.psituacao},
                    
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.msg)){
                        vself.mtdpreparamodalarq(response.data.path)   
                    }else{
                        let tpret = response.data.msg.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.msg.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.msg.substring(4), 'Erro!');
                                break;
                        }

                    }						
                    
                }).catch(function (response) {
                    loader.hide();
                });
            },

            //Luiz Trindade - Método para verificar títulos
            mtdverificartitulo(titulo){
                // console.log("Método para checar títulos");
                // console.log(titulo)

                var vself       = this;
                // let loader      = vself.$loading.show();
                let registrocrud = {
                    "codtit"        : titulo.codtit,
                    "idusuario"     : vself.$store.state.usuario.id,
                    "idfilial"      : vself.$store.state.filialpadrao.codfil,
                    "idcliente"     : titulo.idcliente,
                    "verificado"    : titulo.verificado
                };

                let parametros  = [
                    {parametro: 'op',               valor   : 'verificartitulo'},
                    {parametro: 'idclientesac',     valor   : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor   : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor   : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor   : vself.codopVerificarTitulo},
                    {parametro: 'codtit',           valor   : titulo.codtit},
                    {parametro: 'registro',         valor   : JSON.stringify(registrocrud)},
                    {parametro: 'idcliente',        valor   : titulo.idcliente},
                    {parametro: 'situacao',         valor   : vself.psituacao},
                    {parametro: 'verificado',       valor   : titulo.verificado},
                ];
                
                let retorno = util.reqaxios(
                    parametros, 'post', 
                    vself.$store.state.usuario.adrsrv
                    +'/controller/rtcadtitulosreceberv2.php'
                );

                retorno.then(function (response) {
                    if ($.isNumeric(response.data)){
                        vself.mtdexecutapesquisa();
                    }				
                    
                }).catch(function (response) {
                    ;
                });
            },  

            //Luiz Trindade - Método que abre o modal de ocorrências
            mtdocorrencias(info){
                console.log("Ocorrências!");
                console.log(info);

                //Luiz Trindade - Limpar variáveis antes de abirir o modal
                this.mtdformatarvariaveisocorrencias('t');

                //Luiz Trindade - Atribuição de variáveis
                this.vocodtit           = info.codtit;
                this.voidcliente        = info.idcliente;
                this.vonomecliente      = info.nomecliente;
                this.vonumerocliente    = info.numerocliente;
                this.voemailcliente     = info.email;
                this.vodtocorrencia     = util.DataAtual(true, true).substring(0, 16);
                this.vodtretorno        = util.DataAtual(true, false).substring(0, 16); //

                //Luiz Trindade - Listar as ocorrências do título
                this.mtdlistarocorrencias(this.vocodtit);
            },

            //Luiz Trindade - Método de formatar variáveis de ocorrências
            mtdformatarvariaveisocorrencias(option){
                console.log("Método de formatar variáveis");

                //Luiz Trindade - Se a opção de formatação de variáveis for 't'(total), formatará todas as variáveis
                if (option == 't'){
                    this.lstOcorrencias     = [];
                    this.vocodtit           = '';
                    this.vonomecliente      = '';
                    this.vonumerocliente    = '';
                    this.emailcliente       = '';
                    this.vodtocorrencia     = '';
                    this.voconteudo         = '';
                    this.voretorno          = 0;
                    this.vodtretorno        = util.DataAtual(true, false);
                    this.vodtretornohora    = '14:00';
                }
                //Luiz Trindade - Se a opção de formatação de variáveis for 'p'(parcial), formatará 
                //apenas as variáveis de conteúdo, retorno e data de retorno
                else if (option == 'p'){
                    this.voconteudo         = '';
                    this.voretorno          = 0;
                    this.vodtretorno        = util.DataAtual(true, false);
                    this.vodtretornohora    = '14:00';
                }
            },

            //Luiz Trindade - Método de adicionar ocorrência
            mtdconfirmaadicaoocorrencia(){
                console.log("Método de adicionar ocorrências");

                 //Verificar a hora, se é um valor válido
                 this.mtdvalidarhora(this.vodtretornohora);

                //Adicionar ocorrências no banco de dados
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirmar adição de ocorrência?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                console.log("Inserindo ocorrências no banco de dados!");
                                vself.mtdgravarocorrencia();
                                vself.mtdformatarvariaveisocorrencias('p');
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },

            //Luiz Trindade - Método de imprimir ocorrências
            mtdimprimirocorrencias(){
                console.log("Método de impressão de ocorrências");

                let vself = this;
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&op=imprimirocorrencias'+
                            '&codtit='+vself.vocodtit+
                            '&idusuario='+vself.$store.state.usuario.id+
                            '&idcliente='+vself.voidcliente+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&cliente='+vself.vonomecliente, '_blank');
            },

            //Luiz Trindade - Método de imprimir ocorrências
            mtdimprimirocorrenciasperiodo(){
                console.log("Método de impressão de ocorrências por período");

                let vself = this;
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&op=imprimirocorrenciasperiodo'+
                            '&codtit='+vself.vocodtit+
                            '&dtini='+vself.vodtinicio+
                            '&dtfim='+vself.vodtfim+
                            '&idusuario='+vself.$store.state.usuario.id+
                            '&idnomecliente='+vself.voidnomepesq+
                            '&idusuariocliente='+vself.voidusuariopesq+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordernarpor='+vself.voordernarpor+
                            '&cliente='+vself.vonomecliente, '_blank');
            },

            //Luiz Trindade - Método para pesquisar ocorrências levando em consideração
            //um período e o nome do cliente
            mtdpesquisarocorrencias(){
                let vself = this;
                let parametros = [
                    {parametro: 'op',                   valor: 'listarocorrenciasporperiodo'},
                    {parametro: 'idclientesac',         valor: this.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',            valor: this.$store.state.usuario.id},
                    {parametro: 'dtinicio',             valor: this.vodtinicio},
                    {parametro: 'dtfim',                valor: this.vodtfim},
                    {parametro: 'incluircliente',       valor: this.vocliente},
                    {parametro: 'idusuarioocorrencia',  valor: this.voidusuariopesq},
                    {parametro: 'idnomecliente',        valor: this.voidnomepesq},
                    {parametro: 'ordernarpor',          valor: this.voordernarpor},
                ]

                vself.lstOcorrenciasPeriodo = [];
                let loader      = vself.$loading.show();
                let retorno = util.reqaxios(
                    parametros, 'post', 
                    this.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php'
                );
              
                retorno.then(function (response) {
                    // console.log('Listando ocorrências por período...');

                    vself.lstOcorrenciasPeriodo = response.data;
                    loader.hide();
                })
                .catch(function (){
                    console.log('Erro ao listar ocorrências!');
                    vself.$toastr.e("Erro ao listar ocorrências!", 'Erro!');
                });
            },

            //Luiz Trindade - Função para validar hora
            mtdvalidarhora(hora){
                // Expressão regular para verificar o formato HH:mm:ss
                const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;;

                // Verifica se a hora corresponde ao formato HH:mm:ss
                if (!regex.test(hora)) {
                    this.$toastr.w("Horário inválido!", 'Atenção!');
                    // this.vodtretornohora = "14:00";
                    exit();
                }
            },

            //Luiz Trindade - Método de gravar ocorrência
            mtdgravarocorrencia(){
                if (this.voretorno == 0){
                    this.vodtretorno     = "";
                    this.vodtretornohora = "";
                }
                else{
                    this.vodtretorno += " "+this.vodtretornohora+":00";
                }

                this.vodtocorrencia = util.DataAtual(true, true);

                let parametros = [
                    {parametro: 'op',           valor: 'gravarocorrencia'},
                    {parametro: 'idclientesac', valor: this.$store.state.filialpadrao.idcliente},
                    {parametro: 'codtit',       valor: this.vocodtit},
                    {parametro: 'idusuario',    valor: this.$store.state.usuario.id},
                    {parametro: 'idcliente',    valor: this.voidcliente},
                    {parametro: 'dtocorrencia', valor: this.vodtocorrencia},
                    {parametro: 'dtretorno',    valor: this.vodtretorno},
                    {parametro: 'conteudo',     valor: this.voconteudo},
                ]
                // console.log(parametros);
                let retorno = util.reqaxios(parametros, 'post', this.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                let vself = this;
                retorno.then(function (){
                    vself.mtdlistarocorrencias(vself.vocodtit);
                    vself.$toastr.s("Ocorrência adicionada com sucesso!", 'Sucesso!');
                })
                .catch(function (){
                    console.log('Erro ao gravar ocorrência!');
                    vself.$toastr.e("Erro ao gravar ocorrência!", 'Erro!');
                });
            },

            //Luiz Trindade - Método para alterar ocorrência
            mtdalterarocorrencia(idocorrencia){
                console.log("Método para alterar ocorrência");
            },

            //Luiz Trindade - Método para listar ocorrências por título
            mtdlistarocorrencias(codtit){
                console.log("Método para listar ocorrências");

                let parametros  = [
                    {parametro: 'op',               valor: 'listarocorrencias'},
                    {parametro: 'idclientesac',     valor: this.$store.state.filialpadrao.idcliente},
                    {parametro: 'codtit',           valor: codtit},    
                    {parametro: 'idusuario',        valor: this.$store.state.usuario.id},
                    {parametro: 'idcliente',        valor: this.voidcliente},
                ];
                let retorno = util.reqaxios(parametros, 'post', this.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                let vself = this;
                let loader      = vself.$loading.show();
                retorno.then(function (response) {
                    console.log('Listando ocorrências...');
                    console.log(response);

                    vself.lstOcorrencias = response.data;

                    //Luiz Trindade - Exibir o modal de ocorrências
                    $('#mdlocorrenciastitulo').modal('show');
                    loader.hide();
                })
                .catch(function (){
                    console.log('Erro ao listar ocorrências!');
                });
            },

            //Luiz Trindade - Método para exibir modal da ocorrência individual do título
            mtdexibirmodalocorrencia(index, ocorrenciaID){
                console.log(index);

                this.vodtocorrenciaexibir   = this.lstOcorrencias[index]["dtocorrencia"];
                this.voconteudoexibir       = this.lstOcorrencias[index]["conteudo"];

                console.log("Exibindo modal de visualizar/alterar ocorrência")
                $('#mdlocorrencia').modal('show');
            },

            mtdaplicardesconto(titulo){
                if(!util.opcaousuario('030Z.010Z.120Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    console.log(titulo);
                    this.vlegtitulo =  titulo
                    $('#modaldesconto').modal('show')
                }
            },
            mtdabremodalimp(){
                this.pgrupamento  = 0;
                this.penderecocli = 0;
                this.pordemcli    = 0;
                $('#mddefineimp').modal('show');
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdconsultarcliente(){
				if (parseInt(this.opcrud) < 2){
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);
					let payloadx = {
						idcliente    : null			
					};
					this.$store.commit('CLIENTE_RETORNO_CHANGE',payloadx);                
				}
            },
            mtdlocalizarcliente(idcliente){
				if (idcliente !== '' && idcliente !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgclientes+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and c.id='+idcliente},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let cliente = response.data[0];							
							vself.vidcliente  			    = cliente.id;
							vself.vnomecliente 				= cliente.nome;
							$('#edcodtit').focus();
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidcliente 	= '';
							vself.vnomecliente 	= '';
							$('#edcodcli').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
				}
            },                        
            mtdfiltropesquisa(){
                let rfiltro = '';
                if(this.pidfilial !== null) {                    
                    rfiltro = rfiltro + ' and t.idfilial=' + this.pidfilial;
                }
                if(this.pidfilialbaixa !== null){                    
                    rfiltro = rfiltro + ' and t.idfilialbaixa=' + this.pidfilialbaixa;
                }   
                if (parseInt(this.ptipopessoa) < 3){
                    rfiltro = rfiltro + ' and cli.tipopessoa=' + this.ptipopessoa;
                }              
                if(this.pidcliente !== null) {
                    rfiltro = rfiltro +' and t.idcliente=' + this.pidcliente;
                }
                if(this.pidvendedor !== null) {                    
                    rfiltro = rfiltro + ' and t.idvendedor=' + this.pidvendedor;
                }
                if(this.pidtipocobranca !== null) {
                    rfiltro = rfiltro +' and t.idtipocobranca=' + this.pidtipocobranca;
                }                
                if(this.pidbancoboleto !== null) {                    
                    rfiltro = rfiltro + ' and t.idbancoboleto=' + this.pidbancoboleto;
                }   
                if(this.pidcategoria !== null) {                    
                    rfiltro = rfiltro + ' and cli.idcategoria=' + this.pidcategoria;
                } 
                if(this.pidcidade !== null) {                    
                    rfiltro = rfiltro + ' and cli.idmunicipio=' + this.pidcidade;
                } 
                if(this.pidcobrador !== null) {                    
                    rfiltro = rfiltro + ' and t.idcobrador=' + this.pidcobrador;
                }
                if(this.pidrota !== null) {                    
                    rfiltro = rfiltro + ' and cli.idrota=' + this.pidrota;
                }   
                if(parseInt(this.vtipocobrancapesq)===1){
                    if(this.pidsituacaocheque !== null) {                    
                        rfiltro = rfiltro + ' and t.idsituacaocheque=' + this.pidsituacaocheque;
                    }
                }                                                        
                if(this.pcodauxiliar !== '') {
                    rfiltro = rfiltro + ' and t.codauxiliar="' + this.pcodauxiliar+'"';
                }
				if(parseInt(this.pfiltroperiodo) === 1){
                    let strpor =    parseInt(this.ppor) === 0 ? 'dtventit' : 
                                    parseInt(this.ppor) === 1 ? 'dtemitit' :
                                    parseInt(this.ppor) === 2 ? 'dtpagtit' :
                                    parseInt(this.ppor) === 3 ? 'dtretorno' : 
                                    'dtrenegociacao';

					rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.pdtini)+" 00:00:00" + '" and "' + util.InverterData(this.pdtfim)+" 23:59:59" + '"' + '" AND t.dtretorno != NULL"';
                }
                if (parseInt(this.psituacao) !== 1){
                    if(parseInt(this.pativosinativos) < 2){
                        rfiltro = rfiltro + ' and t.inativo='+this.pativosinativos;
                    }
                }
                switch (parseInt(this.psituacao)) {
                    case 0 :
                        rfiltro = rfiltro + ' and t.sttit in ("A", "P")';
                        break;
                    //Títulos baixados não tem mais o campo sttit    
                    // case 1 :
                    //     rfiltro = rfiltro + ' and t.sttit="B"';
                    //     break;
                    case 2 :
                        rfiltro = rfiltro + ' and t.sttit="C"';
                        break;
                    case 3 :
                        rfiltro = rfiltro + ' and t.sttit="R"';
                        break;
                }                
                return rfiltro;
            },

            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatitulos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },

            mtdcarregatitulos(ipagina){
                var vself       = this;                    
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                vself.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table 
                vself.mtdcalculaselecionados();                   
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'situacao',     valor  : vself.psituacao},
                    {parametro: 'ordem',        valor  : vself.pordem}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(vself.pdtbasebaixa)},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    vself.lsttitulos = response.data.lista;
                    //iguala totais dos titulos para calcular os selecionados
                    if (parseInt(vself.psituacao) !== 1){
                        vself.vrVencidos        = response.data.vencidos;
                        vself.vrAvencer         = response.data.avencer;
                        vself.vrJuros           = response.data.totjuros;
                        vself.vrMulta           = response.data.totmulta;
                        vself.vrTotal           = response.data.totgeral;
                        vself.vrTotcancelados   = response.data.totcancelados;                        
                    }else{
                        vself.vtotaltitulosrec  = response.data.totaltitulos;
                        vself.vtotaljurosrec    = response.data.totaljuros;
                        vself.vtotalmultarec    = response.data.totalmulta;
                        vself.vtotaldescontorec = response.data.totaldescontos;
                        vself.vtotalgeralrec    = response.data.totgeral;                             
                    }
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttitulos = [];
                    loader.hide();
                });
            },
            mtdselect2_def(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
                
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidcliente = $("#cbclientepesq").val();
                    vself.mtdlimpar_listagem();
				});

                $("#cbclientepesq2").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.voidnomepesq = $("#cbclientepesq2").val();
				});

                $("#cbusuariopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbusuarios',
								c1: 'codusu',
								c2: 'nomeusu'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.voidusuariopesq = $("#cbusuariopesq").val();
				});

                $("#cbfilialbaixapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfilialbaixa = $("#cbfilialbaixapesq").val();
                    vself.mtdlimpar_listagem();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidvendedor = $("#cbvendedorpesq").val();
                    vself.mtdlimpar_listagem();
                });

                $("#cbsitchequepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidsituacaocheque = $("#cbsitchequepesq").val();
                    vself.mtdlimpar_listagem();
                });
                
				$("#cbtipocobrancapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidtipocobranca = $("#cbtipocobrancapesq").val();
                    if (vself.pidtipocobranca !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.pidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.vtipocobrancapesq = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.vtipocobrancapesq = 0;
                            loader.hide();
                        });
                    }else{
                        vself.vtipocobrancapesq = 0;
                    }   
                });                

				$("#cbbancoboletopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidbancoboleto = $("#cbbancoboletopesq").val();
                    vself.mtdlimpar_listagem();
                });

				$("#cbcategoriapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcategorias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcategoria = $("#cbcategoriapesq").val();
                }); 

                $("#cbcidadepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcidade = $("#cbcidadepesq").val();
                }); 
                
				$("#cbcobradorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcobradores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcobrador = $("#cbcobradorpesq").val();
                });                
                
				$("#cbrotapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidrota = $("#cbrotapesq").val();
                });

                //selects crud
				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.vidtipocobranca !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.tipocob = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.tipocob = 0;
                            loader.hide();
                        });
                    }else{
                        vself.tipocob = 0;
                    }
                });
				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                });
				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidbanco = $("#cbbanco").val();
                });
				$("#cbsitcheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidsituacaocheque = $("#cbsitcheque").val();
                }); 
				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
                });
				$("#cbcobrador").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcobradores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcobrador = $("#cbcobrador").val();
                }); 
                
                //select atribuição de campos
				$("#cbfilialcampos").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialcampos = $("#cbfilialcampos").val();
                });                            
				$("#cbtipocobrancacampos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidtipocobrancacampos = $("#cbtipocobrancacampos").val();
                    if (vself.vidtipocobrancacampos !== null){
                        let loader      = vself.$loading.show();				
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtipocobrancacampos},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.vtipocobrancacampos = response.data[0].tipo;
                        }).catch(function (response) {
                            vself.vtipocobrancacampos = 0;
                            loader.hide();
                        });
                    }else{
                        vself.vtipocobrancacampos = 0;
                    }                    
                });                        
				$("#cbvendedorcampos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedorcampos = $("#cbvendedorcampos").val();
                });                        
				$("#cbcobradorcampos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcobradores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcobradorcampos = $("#cbcobradorcampos").val();
                }); 
                

				$("#cbcontaboletodef").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcontasbancarias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidcontaboletodef = $("#cbcontaboletodef").val();
                });                
				$("#cbclienteguia").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vclienteguia = $("#cbclienteguia").val();
                });    
				$("#cbcidadeguia").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vcidadeguia = $("#cbcidadeguia").val();
                });    
				$("#cbbairroguia").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbairros',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vbairroguia = $("#cbbairroguia").val();
                });    
				$("#cbfilialguia").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfiliais',
								c1: 'codfil',
								c2: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vfilialguia = $("#cbfilialguia").val();
                });    
				$("#cbrotaguia").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vrotaguia = $("#cbrotaguia").val();
                });    

				$('#mddefinecontaboleto').on('shown.bs.modal', function (e) {
                    vself.vidcontaboletodef = null;
                    $("#cbcontaboletodef").val(null).trigger('change');
                    $("#cbcontaboletodef").select2('open');
				});

                //Luiz Trindade - Executa pesquisa após esconder modal de ocorrências
                $('#mdlocorrenciastitulo').on('hide.bs.modal', function (e) {
                    vself.mtdexecutapesquisa();
				});
            },
            resetarDados() {
                util.toTop();

                this.tipocob             = 0;

                this.vidcliente          = '';
                this.vnomecliente        = '';
                this.vcodtit             = '';
                this.vsttit              = '';
                this.vcodauxiliar        = '';
                this.vidtipocobranca     = null;
                this.vidfilial           = null;
                this.vdtemitit           = util.DataAtual(true);
                this.vdtventit           = util.DataAtual(true);
                this.vnumerocheque       = '';
                this.vidbanco            = null;
                this.vagencia            = '';
                this.vconta              = '';
                this.vpraca              = '';
                this.vemitente           = '';
                this.vcnpjcpf            = '';
                this.vidsituacaocheque   = null;
                this.vidvendedor         = null;
                this.vidcobrador         = null;
                this.vinativo            = 0;
                this.vtpcalcjuros        = 0;
                this.vfatjuros           = 0;
                this.vtpcalcmulta        = 0;
                this.vfatmulta           = 0;
                this.vvltit              = 0;
                this.vobstit             = '';

                $("#cbfilial").val(null).trigger('change');
                $("#cbtipocobranca").val(null).trigger('change');
                $("#cbbanco").val(null).trigger('change');
                $("#cbsitcheque").val(null).trigger('change');
                $("#cbvendedor").val(null).trigger('change');
                $("#cbcobrador").val(null).trigger('change');

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) === 1) {
                        $('#edcodcli').focus();
                    } else if(parseInt(this.opcrud) === 2){
                        $('#edauxiliar').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
                if (parseInt(op) > 1) {
                    vself.ativadesativaCodCli = true;
                    vself.ativadesativaCodTit = true;
                }else{
                    vself.ativadesativaCodCli = false;
                    vself.ativadesativaCodTit = false;
                }
            },
            mtdnovo(){
                if (!util.opcaousuario('030Z.010Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE TÍTULO À RECEBER';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lsttitulos             = [];
                this.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table
                this.pagina_atual           = 1;
                this.filtro                 = '';
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas           = 0;
                this.vrVencidos             = 0;
                this.vrAvencer              = 0;
                this.vrJuros                = 0;
                this.vrMulta                = 0;
                this.vrTotal                = 0;
                this.vrTotcancelados        = 0;
                //variáveis dos baixados    
                this.vtotaltitulosrec       = 0;
                this.vtotaljurosrec         = 0;
                this.vtotalmultarec         = 0;
                this.vtotaldescontorec      = 0;
                this.vtotalgeralrec         = 0;   


                this.mtdcalculaselecionados();
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(idcliente, codtit){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and t.idcliente='+idcliente+' and t.codtit="'+codtit+'"';
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.lista[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('030Z.010Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE TÍTULO À RECEBER';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.idcliente, item.codtit);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('030Z.010Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CANCELAMENTO DE TÍTULO À RECEBER';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.idcliente, item.codtit);
                }
            },
            mtdigualarcampos(registro){
                    this.vidcliente           = registro.idcliente;
                    this.vnomecliente         = registro.nomecliente;
                    this.vcodtit              = registro.codtit;
                    this.vcodauxiliar         = registro.codauxiliar;
                    this.vsttit               = registro.sttit;
                    this.vidtipocobranca      = registro.idtipocobranca;
                    this.vtipocobranca        = registro.ipocob;  
                    this.vdtemitit            = registro.dtemitit;
                    this.vdtventit            = registro.dtventit;
                    this.vdtpagtit            = registro.dtpagtit;
                    if(parseFloat(this.opcrud)===2){
                        this.vvltit               = registro.vlresta;
                    }else{
                        this.vvltit               = registro.vltit;
                    }
                    this.vvlresta             = registro.vlresta;
                    this.vtpcalcjuros         = registro.tpcalcjuros;
                    this.vtpcalcmulta         = registro.tpcalcmulta;
                    this.vfatjuros            = registro.fatjuros;
                    this.vfatmulta            = registro.fatmulta;
                    this.vobstit              = registro.obstit;
                    this.vobstitsis           = registro.obstitsis;
                    this.vnumerocheque        = registro.numerocheque;
                    this.vidbanco             = registro.idbanco;
                    this.vagencia             = registro.agencia;
                    this.vconta               = registro.conta;
                    this.vpraca               = registro.praca;
                    this.vcnpjcpf             = registro.cnpjcpf;
                    this.vemitente            = registro.emitente,
                    this.vidsituacaocheque    = registro.idsituacaocheque;
                    this.vidfilial            = registro.idfilial;
                    this.vidpedido            = registro.idpedido;
                    this.vidvendedor          = registro.idvendedor;
                    this.vvlpagtit            = registro.vlpagtit;
                    this.vnossonumero         = registro.nossonumero;
                    this.vidbancoboleto       = registro.idbancoboleto;
                    this.vidcobrador          = registro.idcobrador;
                    this.vultimojuros         = registro.ultimojuros;
                    this.vdtultpagtit         = registro.dtultpagtit;
                    this.vinativo             = registro.inativo;

                    var deffilial        = new Option(registro.fantasia, registro.idfilial, true, true);
                    $('#cbfilial').append(deffilial).trigger('change');

                    var deftipocobranca  = new Option(registro.desccob, registro.idtipocobranca, true, true);
                    $('#cbtipocobranca').append(deftipocobranca).trigger('change');

                    var defvendedor     = new Option(registro.nomevendedor, registro.idvendedor, true, true);
                    $('#cbvendedor').append(defvendedor).trigger('change');

                    var defcobrador     = new Option(registro.nomecobrador, registro.idcobrador, true, true);
                    $('#cbcobrador').append(defcobrador).trigger('change');
                    
                    if (parseInt(registro.tipocobranca) === 1){
                        var defbanco    = new Option(registro.descbanco, registro.idbanco, true, true);
                        $('#cbbanco').append(defbanco).trigger('change');

                        var defsitch    = new Option(registro.descsitch, registro.idsituacaocheque, true, true);
                        $('#cbsitcheque').append(defsitch).trigger('change');                        
                    }else{
                        $("#cbbanco").val(null).trigger('change');
                        $("#cbsitcheque").val(null).trigger('change');
                    }
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let fantasiafilial = $('#cbfilial').select2('data')[0]['text'];
                let nomecliente    = vself.vnomecliente; 
                let registrocrud = {
                    'idcliente'           : this.vidcliente,
                    'codtit'              : this.vcodtit,
                    'codauxiliar'         : this.vcodauxiliar,
                    'sttit'               : this.vsttit,
                    'idtipocobranca'      : this.vidtipocobranca,
                    'tipocobranca'        : this.tipocob,  
                    'dtemitit'            : this.vdtemitit,
                    'dtventit'            : this.vdtventit,
                    'dtpagtit'            : this.vdtpagtit,
                    'vltit'               : this.vvltit,
                    'vlresta'             : this.vvlresta,
                    'tpcalcjuros'         : this.vtpcalcjuros,
                    'tpcalcmulta'         : this.vtpcalcmulta,
                    'fatjuros'            : this.vfatjuros,
                    'fatmulta'            : this.vfatmulta,
                    'obstit'              : this.vobstit,
                    'obstitsis'           : this.vobstitsis,
                    'numerocheque'        : this.vnumerocheque,
                    'idbanco'             : this.vidbanco,
                    'agencia'             : this.vagencia,
                    'conta'               : this.vconta,
                    'praca'               : this.vpraca,
                    'cnpjcpf'             : this.vcnpjcpf !== null || this.vcnpjcpf !== "" ? this.vcnpjcpf.replace(/[^0-9]/g,'') : "",
                    'emitente'            : this.vemitente,
                    'idsituacaocheque'    : this.vidsituacaocheque === null ? 0 : this.vidsituacaocheque,
                    'idfilial'            : this.vidfilial,
                    'idpedido'            : this.vidpedido,
                    'idvendedor'          : this.vidvendedor,
                    'vlpagtit'            : this.vvlpagtit,
                    'nossonumero'         : this.vnossonumero,
                    'idbancoboleto'       : this.vidbancoboleto,
                    'idcobrador'          : this.vidcobrador,
                    'ultimojuros'         : this.vultimojuros,
                    'dtultpagtit'         : this.vdtultpagtit,
                    'inativo'             : this.vinativo
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '030Z.010Z.010Z' : parseInt(this.opcrud) === 2 ? '030Z.010Z.020Z' : '030Z.010Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pidfilial      = registrocrud.idfilial;
                        vself.pidcliente     = registrocrud.idcliente;
                        vself.pidvendedor    = null;
                        vself.pidbancoboleto = null;
                        vself.pcodauxiliar   = '';
                        vself.pfiltroperiodo = 0;
                        vself.ppor           = 0;
                        vself.pativosinativos= 2;
                        vself.psituacao      = 0;
                        vself.pordem         = 2;
                        vself.pqtd_paginas   = 1;

                        var deffilial        = new Option(fantasiafilial, registrocrud.idfilial, true, true);
                        $('#cbfilialpesq').append(deffilial).trigger('change');

                        var defcliente       = new Option(nomecliente, registrocrud.idcliente, true, true);
                        $('#cbclientepesq').append(defcliente).trigger('change');                        

                        $("#cbvendedorpesq").val(null).trigger('change');
                        $("#cbbancoboletopesq").val(null).trigger('change');
                        vself.mtdcancelaredicao();
                        vself.mtdcarregatitulos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdzerarselecionados() {
                this.vTotalPagarSel       = 0;
                this.vTotalJurosSel       = 0;
                this.vTotalMultaSel       = 0;
                this.vTotalGeralSel       = 0;
            },            
            mtdcalculaselecionados() {
                this.mtdzerarselecionados();
                for (var i = 0; i < this.$refs.reflsttitulos.selected_items.length; i++) {
                    this.vTotalPagarSel    = this.vTotalPagarSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlresta);
                    this.vTotalJurosSel    = this.vTotalJurosSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vljuros);
                    this.vTotalMultaSel    = this.vTotalMultaSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlmulta);
                    this.vTotalGeralSel    = this.vTotalGeralSel + parseFloat(this.$refs.reflsttitulos.selected_items[i].vlapagar);
                }
                this.vqtdtitsel = this.$refs.reflsttitulos.selected_items.length;
            },
            mtdbaixartitulos(){
                if (!util.opcaousuario('030Z.010Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (parseInt(this.pordem) !== 2){
                        this.$toastr.w('Para baixa, a ordem dos títulos deve estar por data de vencimento!', 'Atenção!');
                        $("#cbordempesq").focus();
                        return;
                    }
                    if (this.pdtbasebaixa === null){
                        this.$toastr.w('Data da baixa deve ser informada!', 'Atenção!');
                        $("#eddtbasebaixa").focus();
                        return;
                    }
                    this.vidclientebaixa                       = this.pidcliente; 
                    this.idnomeclientebaixa                    = this.pidcliente +' - ' + $('#cbclientepesq').select2('data')[0]['text'];
                    this.vvariaveisbaixar.vtottitbaixa         = this.vTotalPagarSel;
                    this.vvariaveisbaixar.vtotjurosbaixa       = this.vTotalJurosSel;
                    this.vvariaveisbaixar.vtotmultabaixa       = this.vTotalMultaSel;
                    this.vvariaveisbaixar.vtotpagarbaixa       = this.vTotalGeralSel;
                    this.valdescontojuros                      = this.vTotalJurosSel;
                    this.valdescontomulta                      = this.vTotalMultaSel;
                    this.vvariaveisbaixar.lstselecionadosbaixa = this.$refs.reflsttitulos.selected_items;
                    this.vvariaveisbaixar.vvalorrecebimento    = this.vTotalGeralSel;

                    $('#mdBaixarTitulosReceber').modal('show');
                }
            },
            mtdestornarbaixa(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.010Z.060Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Esse processo irá estornar, também, todos os pagamentos feitos depois deste. Deseja mesmo realizar o estorno do pagamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarbaixa'},
                                        {parametro: 'idmovir',      valor : titulo.id},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.010Z.060Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_RECEBER_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtdestornarcancelamento(titulo){
                let vself = this;
                if (!util.opcaousuario('030Z.010Z.050Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma estorno de cancelamento do título "'+titulo.codtit+'"?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',           valor : 'estornarcancelamento'},
                                        {parametro: 'codtit',       valor : titulo.codtit},
                                        {parametro: 'idcliente',    valor : titulo.idcliente},
                                        {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',        valor : '030Z.010Z.050Z'}
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Título estornado com sucesso!', 'Informação!');
                                            //reaproveitei o payload da baixa ;)
                                            let payload = {
                                                retorno    : 1
                                            };
                                            vself.$store.commit('RETORNO_BAIXA_RECEBER_CHANGE',payload);                        
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'A':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }                    
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $("#cbformapagamentobaixa").focus();
                                }
                            }
                        }
                    });
                }
            },
            mtddetalhestitulo(idcliente, codtit, situacao){
                if (!util.opcaousuario('030Z.010Z.070Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    this.didcliente = idcliente;
                    this.dcodtit    = codtit;
                    this.dsituacao  = situacao;
                    $('#mdDetalhesTitulos').modal('show');
                }
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('030Z.010Z.080Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'IMPORTAÇÃO DE CONTAS À RECEBER';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado     = null;                        
                    this.vlimpardados       = false;
                    this.vimportarcodigos   = false;                        
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizimportarcr.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    vself.$toastr.w('O arquivo selecionado não possui um formato válido', 'Atenção!');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstclientes= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let opcodigos        = vself.vimportarcodigos === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarcr.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&importarcodigos='+opcodigos+'&codop=030Z.010Z.080Z';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdModalPreencherEmail(){
                this.vemailimpressao = '';
                $('#mddefineimpemail').modal('show');
            },
            mtdEnviarPdfEmail(){
                let vself = this;

                
                let loader = vself.$loading.show();
                let parametros = [ 
                    { parametro: 'op',            valor: 'enviarpdfemail' },
                    { parametro: 'idclientesac',  valor: vself.$store.state.filialpadrao.idcliente },
                    { parametro: 'idcliente',     valor: vself.pidcliente },
                    { parametro: 'emailcliente',  valor: vself.vemailimpressao ? vself.vemailimpressao : '' },
                    { parametro: 'filtro',        valor: vself.mtdfiltropesquisa() },
                    { parametro: 'situacao',      valor: vself.psituacao },
                    { parametro: 'dtini',         valor: vself.pdtini },
                    { parametro: 'dtfim',         valor: vself.pdtfim },
                    { parametro: 'idfilial',      valor: vself.$store.state.filialpadrao.codfil },
                    { parametro: 'dtbasecalculo', valor: util.InverterData(vself.pdtbasebaixa) },
                    { parametro: 'mostraend',     valor: vself.penderecocli },
                    { parametro: 'ordemcli',      valor: vself.pordemcli },
                    { parametro: 'agrupamento',   valor: vself.pgrupamento },
                    { parametro: 'excel',         valor: '0' },
                    { parametro: 'usuario',       valor: vself.$store.state.usuario.nome },
                    { parametro: 'ordem',         valor: vself.pordem }
                ];

                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('E-mail enviado com sucesso!', 'Informação!');
                        
                        $('#mddefineimp').modal('hide');
                        $('#mddefineimpemail').modal('hide');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data.message, 'Erro!');
                        $('#mddefineimpemail').modal('hide');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    $('#mddefineimpemail').modal('hide');
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });

            },
            mtdgerarpdf(exc){
                let vself   = this;
                let filtro  = vself.mtdfiltropesquisa();
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
                            '&op=exportar'+
                            '&filtro='+filtro+
                            '&situacao='+vself.psituacao+
                            '&dtbasecalculo='+util.InverterData(vself.pdtbasebaixa)+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
                            '&mostraend='+vself.penderecocli+
                            '&ordemcli='+vself.pordemcli+
                            '&agrupamento='+vself.pgrupamento+
                            '&excel='+exc+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordem='+vself.pordem, '_blank');					                
            },
            mtdimprimecartacobranca(){
                let vself = this;
                if (vself.pidcliente === null) {
                    this.$toastr.i('Campo de cliente deve ser preenchido!', 'Informação!');
                    return;
                }

                
                window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                            '&op=imprimecartacobranca'+
                            '&filtro='+vself.mtdfiltropesquisa()+
                            '&situacao='+vself.psituacao+
                            '&dtbasecalculo='+util.InverterData(vself.pdtbasebaixa)+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
                            '&idcliente='+vself.pidcliente+
                            '&mostraend='+vself.penderecocli+
                            '&ordemcli='+vself.pordemcli+
                            '&agrupamento='+vself.pgrupamento+
                            '&usuario='+vself.$store.state.usuario.nome+
                            '&ordem='+vself.pordem, '_blank');
            },
            mtdrotinacampos(){
                if (!util.opcaousuario('030Z.010Z.090Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (this.$refs.reflsttitulos.selected_items.length === 0){
                        this.$toastr.w('Selecione os títulos para a atribuição dos campos!', 'Atenção!');
                        return;
                    }
                    //atribuição de campos			
                    this.vatribuirsituacao 	    = false;
                    this.vsituacaocampos		= 1;

                    this.vatribuirauxiliar	    = false;
                    this.vauxiliarcampos		= '';

                    this.vatribuirobstit	    = false;
                    this.vobstit		        = '';

                    this.vatribuiridfilial	    = false;
                    this.vidfilialcampos		= null;

                    this.vatribuiridtipocobranca= false;
                    this.vidtipocobrancacampos	= null;
                    this.vtipocobrancacampos    = 0;

                    this.vatribuiridvendedor	= false;
                    this.vidvendedorcampos		= null;

                    this.vatribuiridcobrador	= false;
                    this.vidcobradorcampos		= null;

                    this.vatribuirjuros         = false;
                    this.vtpcalcjuroscampos     = 0;
                    this.vfatjuroscampos        = 0;

                    this.vatribuirmulta         = false;
                    this.vtpcalcmultacampos     = 0;
                    this.vfatmultacampos        = 0;
                    
                    this.vatribuitodostitulos   = false;

                    $('#cbfilialcampos').val(null).trigger('change');
                    $('#cbtipocobrancacampos').val(null).trigger('change');
                    $('#cbvendedorcampos').val(null).trigger('change');
                    $('#cbcobradorcampos').val(null).trigger('change');

                    $('#mdatribuircampos').modal('show');
                }                 
            },
            mtdatribuircampos(){
                let vself = this;                
                if (!this.vatribuirsituacao && !this.vatribuirauxiliar && !this.vatribuirobstit &&
                    !this.vatribuiridfilial && !this.vatribuiridtipocobranca && 
                    !this.vatribuiridvendedor && !this.vatribuiridcobrador && 
                    !this.vatribuirjuros && !this.vatribuirmulta){
					this.$toastr.w('Selecione ao menos um campo para a atribuição!', 'Atenção!');
					return;
                }

				if (this.vatribuiridfilial === true && this.vidfilialcampos === null){
					this.$toastr.w('Campo "Filial" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbfilialcampos').focus();
					return;
                }
				if (this.vatribuiridtipocobranca === true && this.vidtipocobrancacampos === null){
					this.$toastr.w('Campo "Tipo de cobrança" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbtipocobrancacampos').focus();
					return;
                }
				if (this.vatribuiridvendedor === true && this.vidvendedorcampos === null){
					this.$toastr.w('Campo "Vendedor" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbvendedorcampos').focus();
					return;
                }
				if (this.vatribuiridcobrador === true && this.vidcobradorcampos === null){
					this.$toastr.w('Campo "Cobrador" foi selecionado, portanto, deve ser informado!', 'Atenção!');
					$('#cbcobradorcampos').focus();
					return;
                }

                let stratribuir = "";
   
                if (this.vatribuirsituacao){
                    stratribuir = 'inativo='+this.vsituacaocampos+', ';
                }
                if (this.vatribuirauxiliar){
                    stratribuir = stratribuir + 'codauxiliar="'+this.vauxiliarcampos+'", ';
                }
                if (this.vatribuirobstit){
                    stratribuir = stratribuir + 'obstit="'+this.vobstit+'", ';
                }

                if (this.vatribuiridfilial){
                    stratribuir = stratribuir + 'idfilial='+this.vidfilialcampos+', ';
                }
                if (this.vatribuiridtipocobranca){
                    stratribuir = stratribuir + 'idtipocobranca='+this.vidtipocobrancacampos+', tipocobranca='+this.vtipocobrancacampos+', ';
                }
                if (this.vatribuiridvendedor){
                    stratribuir = stratribuir + 'idvendedor='+this.vidvendedorcampos+', ';
                }
                if (this.vatribuiridcobrador){
                    stratribuir = stratribuir + 'idcobrador='+this.vidcobradorcampos+', ';
                }         
   
                if (this.vatribuirjuros){
                    stratribuir = stratribuir + 'tpcalcjuros='+this.vtpcalcjuroscampos+', fatjuros='+this.vfatjuroscampos+', ';
                }
        
                if (this.vatribuirmulta){
                    stratribuir = stratribuir + 'tpcalcmulta='+this.vtpcalcmultacampos+', fatmulta='+this.vfatmultacampos+', ';
                }

                if (stratribuir !== ""){
                    stratribuir = stratribuir.substring(0, stratribuir.length - 2);//remove a ", " do final da string
                }

                console.log(stratribuir);
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma a atribuição dos campos aos títulos selecionados?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: true,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                this.buttons.sim.disable();
                                setTimeout(function(){                                    
                                    let lsttitulosatribuir = vself.$refs.reflsttitulos.selected_items;
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuircampos'},
                                        {parametro: 'stratribuir',      valor : stratribuir},
                                        {parametro: 'atribuirtodos',    valor : vself.vatribuitodostitulos ? 1 : 0},                                        
                                        {parametro: 'idlocalizacao',    valor : vself.vidlocalizacaoatribuir},                                        
                                        {parametro: 'titulos',          valor : JSON.stringify(lsttitulosatribuir)},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '030Z.010Z.090Z'},//verificar esse código
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceber.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuircampos').modal('hide');
                                            vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            vself.mtdcarregatitulos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });                                    
                                },200);                                    
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btconfirmar').focus();
                            }
                        }
                    }
                });
            },
            mtdgerarparcelas(op){
                if(op === 1){
                    if (!util.opcaousuario('030Z.010Z.100Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {                                                     
                        $('#mdgerarparcelas').modal('show');
                    }
                }else{
                    if (!util.opcaousuario('030Z.010Z.100Z', this.$store.state.perfilusuario)){
                        this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    }else {                                                     
                        $('#mdgerarparcelasgrupo').modal('show');
                    }
                }
            },

            //Luiz Trindade - Método para pesuqisar e guardar em uma lista
            mtdlistartotalfilial(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'totalfilial'},
                    {parametro: 'dtini',            valor : vself.pdtini},
                    {parametro: 'dtfim',            valor : vself.pdtfim},
                    {parametro: 'tptit',            valor : vself.tptit},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function(response){
                    loader.hide();
                    vself.lstDadosGraficoTotalFilial = [];
                    vself.lstLegendasGraficoTotalFilial = [];

                    vself.lstDadosGraficoQuantidade = [];
                    vself.lstLegendasGraficoFilial  = [];

                    vself.vtotalfilialgeral         = 0.0;
                    vself.vtotalfilialjuros         = 0.0;
                    vself.vtotalfilialmulta         = 0.0;
                    vself.vtotalfilialdescontos     = 0.0;
                    vself.vtotalfilialtitulos       = 0.0;

                    for (let i = 0; i < response.data.length; i++) {
                        vself.lstDadosGraficoTotalFilial.push(
                            {value: parseFloat(response.data[i].totalgeral), name: String(response.data[i].fantasia)}
                        );

                        vself.lstDadosGraficoQuantidade.push(
                            {value: parseFloat(response.data[i].totalgeral)}
                        );
                        vself.lstLegendasGraficoFilial.push(
                            {value: String(response.data[i].fantasia)}
                        );

                        vself.vtotalfilialgeral         += parseFloat(response.data[i].totalgeral);
                        vself.vtotalfilialjuros         += parseFloat(response.data[i].totaljuros);
                        vself.vtotalfilialmulta         += parseFloat(response.data[i].totalmulta);
                        if (vself.tptit == 1){
                            vself.vtotalfilialdescontos  += parseFloat(response.data[i].descontos);
                        }
                        vself.vtotalfilialtitulos       += parseFloat(response.data[i].totaltitulos);
                    }
                    vself.lstLegendasGraficoTotalFilial = util.gerardadoslegendagrafico(vself.lstLegendasGraficoTotalFilial);

                    vself.lstTotalfilial = response.data;
                }).catch(function(response){
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },

            //Luiz Trindade - Método para abrir o modal com informações individuais por filial
            mtdtotalporfilial(){
                let vself = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'totalfilial'},
                    {parametro: 'dtini',            valor : vself.pdtini},
                    {parametro: 'dtfim',            valor : vself.pdtfim},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function(response){
                    loader.hide();
                    vself.lstDadosGraficoTotalFilial = [];
                    vself.lstLegendasGraficoTotalFilial = [];

                    vself.lstDadosGraficoQuantidade = [];
                    vself.lstLegendasGraficoFilial  = [];

                    vself.vtotalfilialgeral         = 0.0;
                    vself.vtotalfilialjuros         = 0.0;
                    vself.vtotalfilialmulta         = 0.0;
                    vself.vtotalfilialdescontos     = 0.0;
                    vself.vtotalfilialtitulos       = 0.0;

                    for (let i = 0; i < response.data.length; i++) {
                        vself.lstDadosGraficoTotalFilial.push(
                            {value: parseFloat(response.data[i].totalgeral), name: String(response.data[i].fantasia)}
                        );

                        vself.lstDadosGraficoQuantidade.push(
                            {value: parseFloat(response.data[i].totalgeral)}
                            );
                        vself.lstLegendasGraficoFilial.push(
                            {value: String(response.data[i].fantasia)}
                        );

                        vself.vtotalfilialgeral         += parseFloat(response.data[i].totalgeral);
                        vself.vtotalfilialjuros         += parseFloat(response.data[i].totaljuros);
                        vself.vtotalfilialmulta         += parseFloat(response.data[i].totalmulta);
                        if (vself.tptit == 1){
                            vself.vtotalfilialdescontos  += parseFloat(response.data[i].descontos);
                        }
                        vself.vtotalfilialtitulos       += parseFloat(response.data[i].totaltitulos);
                    }
                    vself.lstLegendasGraficoTotalFilial = util.gerardadoslegendagrafico(vself.lstLegendasGraficoTotalFilial);

                    vself.lstTotalfilial = response.data;
                    $('#mdltotalfilial').modal('show');
                }).catch(function(response){
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },

            //Luiz Trindade - Método para abrir o modal de listar ocorrências por período
            mtdocorrenciasporperiodo(){
                //Luiz Trindade - Formatar variáveis do modal antes de manipular
                this.vodtinicio     = util.DataAtual(true, false);
                this.vodtfim        = util.DataAtual(true, false);
                this.vocliente      = 0;
                this.voidnomepesq   = null;
                $("#cbclientepesq2").val(null).trigger('change');
                this.lstOcorrenciasPeriodo = [];

                //Luiz Trindade - Exibir o modal
                $('#mdlocorrenciasperiodo').modal('show');
            },

            //Luiz Trindade - Botão para alterar o tipo de exibição do gráfico
            mtdalterargrafico(){
                this.tipografico += 1;
                if (this.tipografico > this.qntdgraficos-1){
                    this.tipografico = 0;
                }
            },

            //Akira - Método de impressão
            mtdimprimirtotalfilial(){
                let vself   = this;
                let filtro = '';
                if(parseInt(vself.tptit) === 0){
                    filtro  = 'AND tr.dtventit BETWEEN "' + util.InverterData(vself.pdtini+" 00:00:00") + '" AND "' + util.InverterData(vself.pdtfim+" 23:59:59") + '"';
                } else {
                    filtro  = 'tr.dtpagtit BETWEEN "' + util.InverterData(vself.pdtini) + '" AND "' + util.InverterData(vself.pdtfim) + '"';
                }
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&op=imprimirtotfil'+
							'&imprimirgrfilial=0'+
                            '&filtro='+filtro+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
                            '&tptitulo='+vself.tptit+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');
            },

			mtddetalhespedido(idpedido){
                this.vidpedidodet = 0;
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},
            mtddefinircontaboletos(){
                if (!util.opcaousuario('030Z.010Z.110Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                                     
                    if (this.$refs.reflsttitulos.selected_items.length > 0){
                        $('#mddefinecontaboleto').modal('show');
                    }else{
                        this.$toastr.w('Selecione os títulos para definição da conta para emissão dos boletos!', 'Informação!');
                    }
                }
            },
            mtdatribuircontabancaria(){
                let vself = this;
                if (vself.vidcontaboletodef !== null){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma atribuição da conta para emissão dos boletos?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    $.confirm({
                                        title: 'Impressão',
                                        content: 'Deseja imprimir automaticamente?',
                                        icon: 'fa fa-print',
                                        escapeKey: true,
                                        backgroundDismiss: false,
                                        type: 'blue',
                                        buttons: {
                                            sim: {
                                                text: '<u>S</u>im',
                                                btnClass: 'btn-green',
                                                action: function () {
                                                    vself.mtdgravarcontabancariaboletos(1);
                                                }
                                            },
                                            nao: {
                                                text: '<u>N</u>ão',
                                                btnClass: 'btn-red',
                                                action: function () {
                                                    vself.mtdgravarcontabancariaboletos(2);
                                                }
                                            }
                                        }
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }else{
                    vself.$toastr.w('Conta bancária deve ser informada!', 'Informação!');                    
                    $('#cbcontaboletodef').select('open');
                }
            },
            mtdgravarcontabancariaboletos(imp){
                let vself  = this;
                let loader = vself.$loading.show();
                let dados = {
                    'idconta'               : vself.vidcontaboletodef,
                    'titulos'               : this.$refs.reflsttitulos.selected_items
                };
                // console.log(vself.$refs.reflsttitulos.selected_items);
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'atribuircontaboleto'},
                    {parametro: 'dados',        valor : JSON.stringify(dados)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '030Z.010Z.110Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.ret)){
                        $('#mddefinecontaboleto').modal('hide');
                        vself.$toastr.s('Conta bancária definida com sucesso!', 'Informação!'); 
                        vself.pqtd_paginas   = 1;
                        if(imp === 1){
                            vself.mtdimprimirboleto(vself.$refs.reflsttitulos.selected_items);
                            vself.mtdlimpar_listagem();
                        }else{
                            vself.mtdlimpar_listagem();
                        }
                        $("#cbvendedorpesq").val(null).trigger('change');
                        $("#cbbancoboletopesq").val(null).trigger('change');
                        vself.mtdcarregatitulos(1);                                          
                    }else{
                        let tpret = response.data.ret.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
                                $('#mddefinecontaboleto').modal('hide');
                                vself.mtdcarregatitulos(1); 
                                break;
                        }
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                    $('#mddefinecontaboleto').modal('hide');
                });                               
            },
            mtdimprimirboleto(titulo) {
                let dados = [];
                if (Array.isArray(titulo)) { // Quando imp === 1
                    let titulos = titulo.map(item => ({
                        codtit: item.codtit,
                        idcliente: item.idcliente
                    }));

                    dados = { josntitulos: titulos };
                } else {
                    dados = {
                        josntitulos: [{
                            codtit: titulo.codtit,
                            idcliente: titulo.idcliente
                        }]
                    };
                }
                window.open(this.$store.state.configpaths.pathcontrole + 'rtcadcobrancasbancarias.php?op=gerarboleto' +
                    '&dados=' + encodeURIComponent(JSON.stringify(dados)) +
                    '&idclientesac=' + this.$store.state.filialpadrao.idcliente,
                    '_blank');
            },
            mtdimprimeboletoemassa(){   
                let bancoDoPrimeiroTitulo = this.$refs.reflsttitulos.selected_items[0].idbancoboleto;
                let titulos = []    
                let qtdbreaks = 0
                if (this.$refs.reflsttitulos.selected_items.length > 0){
                    if(this.$refs.reflsttitulos.selected_items.length > 25){
                        this.$toastr.w('Os títulos selecionados excedem a quantidade permitida de 25!', 'Informação!');
                        return
                    }
                    for (let index = 0; index < this.$refs.reflsttitulos.selected_items.length; index++) {
                        if(parseInt(this.$refs.reflsttitulos.selected_items[index].nossonumero) > 0){
                            let titulo = this.$refs.reflsttitulos.selected_items[index];
                            if (titulo.idbancoboleto !== bancoDoPrimeiroTitulo) {
                                this.$toastr.w('Os títulos selecionados pertencem a bancos diferentes!', 'Informação!');
                                qtdbreaks++
                                break
                            }else{
                                let titulostmp = {
                                    codtit   :  this.$refs.reflsttitulos.selected_items[index].codtit,
                                    idcliente:  this.$refs.reflsttitulos.selected_items[index].idcliente
                                }  
                                titulos.push(titulostmp)
                            }
                        }else{
                            this.$toastr.w('Alguns dos títulos selecionados não apresentam definição de banco!', 'Informação!');
                            qtdbreaks++
                            break
                        }
                    }
                    if(qtdbreaks === 0){
                        let dados = {
                            josntitulos: titulos
                        };
                        
                        //passar url
                        window.open(this.$store.state.configpaths.pathcontrole+'rtcadcobrancasbancarias.php?op=gerarboleto'+
                            '&dados=' + encodeURIComponent(JSON.stringify(dados))+
                            '&idclientesac='+this.$store.state.filialpadrao.idcliente,
                            '_blank');
                        qtdbreaks = 0
                    }
                }else{
                    this.$toastr.w('Selecione os títulos para impressão!', 'Informação!');
                }
            },
            mtdimprimepromissoriaemassa(){   
                let titulos = []    
                let qtdbreaks = 0
                if (this.$refs.reflsttitulos.selected_items.length > 0){
                    if(this.$refs.reflsttitulos.selected_items.length > 25){
                        this.$toastr.w('Os títulos selecionados excedem a quantidade permitida de 25!', 'Informação!');
                        return
                    }
                    for (let index = 0; index < this.$refs.reflsttitulos.selected_items.length; index++) {
                        let titulostmp = {
                            codtit   :  this.$refs.reflsttitulos.selected_items[index].codtit,
                            idcliente:  this.$refs.reflsttitulos.selected_items[index].idcliente
                        }  
                        titulos.push(titulostmp)
                    }
                    if(qtdbreaks === 0){
                        let dados = {
                            josntitulos: titulos
                        };
                        
                        //passar url
                        window.open(this.$store.state.configpaths.pathcontrole+'rtcadtitulosreceberv2.php?op=gerarpromissoria'+
                            '&dados=' + encodeURIComponent(JSON.stringify(dados))+
                            '&idclientesac='+this.$store.state.filialpadrao.idcliente,
                            '_blank');
                        qtdbreaks = 0
                    }
                }else{
                    this.$toastr.w('Selecione os títulos para impressão!', 'Informação!');
                }
            },
            mtdimprimereciboemassa(){   
                let titulos = []    
                let qtdbreaks = 0
                if (this.$refs.reflsttitulos.selected_items.length > 0){
                    if(this.$refs.reflsttitulos.selected_items.length > 25){
                        this.$toastr.w('Os títulos selecionados excedem a quantidade permitida de 25!', 'Informação!');
                        return
                    }
                    for (let index = 0; index < this.$refs.reflsttitulos.selected_items.length; index++) {
                        let titulostmp = {
                            codtit   : this.$refs.reflsttitulos.selected_items[index].codtit,
                            idcliente: this.$refs.reflsttitulos.selected_items[index].idcliente
                        }  
                        titulos.push(titulostmp)
                    }
                    console.log('titulos:', titulos);
                    if(qtdbreaks === 0){
                        let dados = {
                            josntitulos: titulos
                        };
                        $.confirm({
                            title: 'Confirmação!',
                            content: 'Qual Recibo Simplificado deseja exibir?',
                            icon: 'fa fa-question-circle',
                            escapeKey: true,
                            backgroundDismiss: false,
                            escapeKey: 'layout2',
                            type: 'dark',
                            typeAnimated: true,
                            buttons: {
                                layout1: {
                                    text: 'Layout 1',
                                    btnClass: 'btn-blue',
                                    action: () => {
                                        window.open(
                                            this.$store.state.configpaths.pathcontrole+
                                            'rtcadtitulosreceberv2.php?op=gerarrecibosimplificado'+
                                            '&dados=' + encodeURIComponent(JSON.stringify(dados))+
                                            '&idclientesac='+this.$store.state.filialpadrao.idcliente+
                                            '&layoutrecibo=0',
                                            '_blank'
                                        );
                                        qtdbreaks = 0
                                    },
                                },
                                layout2: {
                                    text: 'Layout 2',
                                    btnClass: 'btn-green',
                                    action: () => {
                                        window.open(
                                            this.$store.state.configpaths.pathcontrole+
                                            'rtcadtitulosreceberv2.php?op=gerarrecibosimplificado'+
                                            '&dados=' + encodeURIComponent(JSON.stringify(dados))+
                                            '&idclientesac='+this.$store.state.filialpadrao.idcliente+
                                            '&layoutrecibo=1',
                                            '_blank'
                                        );
                                        qtdbreaks = 0
                                    }
                                }
                            }
                        });
                    }
                } else {
                    this.$toastr.w('Selecione os títulos para impressão!', 'Informação!');
                }
            },

			mtdvisualizaralerta(idcliente){
				this.vidclientealerta = 0;//mudo antes o valor pro componente entender que houve alteração do valor pra poder reagir
				this.vidclientealerta = idcliente;
				$('#mdconteudoalertacliente').modal('show');				
			},
            
            // Luiz Trindade - Verificar a permissão de usuário para registrar ocorrências
            mtdpermissaoocorrencia(){
                if (util.opcaousuario("030Z.010Z.130Z", this.$store.state.perfilusuario)){
                    this.usuarioPermissaoOcorrencia = true;
                } 
                else {
                    this.usuarioPermissaoOcorrencia = false;
                }
            },

            // Luiz Trindade - Verificar a permissão de usuário para listar ocorrências
            mtdpermissaoocorrenciaperiodo(){
                if (util.opcaousuario("030Z.010Z.140Z", this.$store.state.perfilusuario)){
                    this.usuarioPermissaoOcorrenciaPeriodo = true;
                } 
                else {
                    this.usuarioPermissaoOcorrenciaPeriodo = false;
                }
            },

            // Luiz Trindade - Verificar a permissão de usuário para verificar títulos
            mtdpermissaoverificartitulo(){
                if (util.opcaousuario(this.codopVerificarTitulo, this.$store.state.perfilusuario)){
                    // this.usuarioPermissaoVerificarTitulo = true;
                    this.columnsbaixados[17].visibility = true;
                } 
                else {
                    // this.usuarioPermissaoVerificarTitulo = false;
                    this.columnsbaixados[17].visibility = false;
                }
            },
            mtdgerarlinkrillpay(infos){
                this.idclienterp = infos.idcliente;
                this.nomeclienterp = infos.nomecliente;
                this.$modal.show('mdl-gerar-link-rillpay');
            },
        },

        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    //Luiz Trindade - Método para verificar permissão de registrar ocorências
                    vself.mtdpermissaoocorrencia();
                    
                    //Luiz Trindade - Método para verificar permissão de listar ocorências
                    vself.mtdpermissaoocorrenciaperiodo();
                    vself.mtdpermissaoverificartitulo();

                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('030Z.010Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdcarregatitulos(vself.pagina_atual);
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

                $('#modaldesconto').on('hide.bs.modal', function (e) {
                    vself.mtdexecutapesquisa();
                });
            }
        },
        computed:{
            validou() {
                if(parseInt(this.tipocob) === 0) {
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vidvendedor === null || this.vidcobrador === null || this.vvltit === 0 || 
                            this.vdtemitit === '' || this.vdtventit === '';
                }else{
                    return  this.vcodtit === '' || this.vidtipocobranca === null || this.vidfilial === null ||
                            this.vidvendedor === null || this.vidcobrador === null || this.vvltit === 0 || this.vnumerocheque === '' ||
                            this.vidbanco === null || this.vagencia === '' || this.vconta === '' ||
                            this.vpraca === '' || this.vemitente === '' || this.vcnpjcpf === '' || this.vidsituacaocheque === null || 
                            this.vdtemitit === '' || this.vdtventit === '';
                }
            },
            idclienteretorno(){
                return this.$store.state.clienteretornoconsulta.idcliente;
			},            
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
            retornobaixa(){
               return this.$store.state.retornobaixareceber.retorno; 
            },
           
        },
        watch:{
            idclienteretorno(val){
                if (val !== null || val !== ''){
					this.vidcliente = val;
					this.mtdlocalizarcliente(this.vidcliente);					
                }
			},
            vlimpardados(val){
                this.vimportarcodigos = false;
            },            
            pagina_atual(val){
                this.mtdcarregatitulos(val);
            },
            psituacao(val){
                this.config.checkbox_rows = parseInt(val) === 0 ? true : false;
                if(parseInt(this.psituacao) !== 1){
                    this.pidfilialbaixa = null;
                    $("#cbfilialbaixapesq").val(null).trigger('change');
                }
                if (parseInt(val) === 1){
                    this.pordem = 2;
                }
            },

            retornobaixa(val){
                let vself = this;
                if (parseInt(val) === 1){
                    //dispara a mutation pra esperar pela próxima baixa
                    let payload = {
                        retorno    : 0
                    };
                    vself.$store.commit('RETORNO_BAIXA_RECEBER_CHANGE',payload);
                    vself.pidvendedor    = null;
                    vself.pidbancoboleto = null;
                    vself.pcodauxiliar   = '';
                    vself.pfiltroperiodo = 0;
                    vself.ppor           = 0;
                    vself.pativosinativos= 2;
                    vself.psituacao      = 0;
                    vself.pordem         = 2;
                    vself.pqtd_paginas   = 1;
                    vself.mtdlimpar_listagem();
                    $("#cbvendedorpesq").val(null).trigger('change');
                    $("#cbbancoboletopesq").val(null).trigger('change');
                    vself.mtdcarregatitulos(1);                    
                }
            },
          
            verific(){
                console.log(vself.$store.state.usuario)
            }                        
        }
    }
</script>
<style>
    .corverde{
        background-color: rgb(51, 148, 116) !important;
        border-color: rgb(51, 148, 116) !important;
    }
    .corvermelho{
        background-color: rgb(224, 33, 33) !important;
        border-color: rgb(224, 33, 33) !important;
    }
    .def-col-status{
        width: 5px !important;
        position: relative;
    }
    .tooltip-status{
        position: absolute;
        visibility: hidden;
        white-space: nowrap;
        width: 700px;
        max-width: 70vw;
        text-wrap: auto;
        background-color: #b63d3d;
        color: #ffffff;
        border-radius: 6px;
        border: 1px solid #8f8f8f;
        box-shadow: 4px 4px 5px -1px rgba(0,0,0,0.75);
        padding: 5px;
        z-index: 1;
        bottom: 80%;
        left: 60px;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.4s;
    }

    .def-col-status:hover .tooltip-status{
        visibility: visible;
        opacity: 1;
    }

    .def-col-nossonumero{
        position: relative;
    }

    .tooltip-boleto-erro{
        position: absolute;
        visibility: hidden;
        white-space: nowrap;
        width: 200px;
        text-wrap: auto;
        background-color: #b63d3d;
        color: #ffffff;
        border-radius: 6px;
        border: 1px solid #8f8f8f;
        box-shadow: 4px 4px 5px -1px rgba(0,0,0,0.75);
        padding: 5px;
        z-index: 1;
        bottom: 80%;
        right: 40px;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.4s;
    }

    .def-col-nossonumero:hover .tooltip-boleto-erro{
        visibility: visible;
        opacity: 1;

    }

    .def-col-opcoes-abertos{
        width: 80px !important;
    }
    .def-col-codtit{
        width: 120px !important;
    }
    .def-col-femissao{
        width: 100px !important;
    }
    .lstdetrec{
        padding: 5px!important;
        font-weight: 700;
        color: #6c757d!important;
    }
    .bdgtitulos{
        margin-top: 2px;
        float : right!important;
        font-size: 12px!important;
        width: 100px!important;
        text-align: right!important;
    }
    .def-col-nossonumero{
        width: 100px !important;
    }
    .icone-alerta-erro{
    transition: all .3s ease!important;
    cursor: pointer;
    font-size: 25px;
    color: #f82b54;
    animation: animate 
    1.5s linear infinite;    
    }
    .icone-alerta-erro:hover{
        transition: all .3s ease!important;
        filter: brightness(80%)!important;    
    }
    @keyframes animate {
        0% {
            opacity: 0;
        }

        50% {
            opacity: 0.7;
        }

        100% {
            opacity: 0;
        }
    }
</style>